// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23aaa%27 stroke-width=%272.5%27%3E%3Cpath d=%27M6 9l6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@500&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* :root {
  --sidebar-width: 20%;
}

.bodyContainer {
  height: 100vh;
  display: flex;
}

.sidebarMain {
  width: var(--sidebar-width);
  background-color: #fff;
  height: 100vh;
  transition: width 0.3s ease-in-out;
  overflow: auto;
}

.sidebarHidden {
  width: 0;
}

.sidebarVisible {
  width: var(--sidebar-width);
}
.brandLogo img {
  height: 50px;
}
.brandLogo p {
  font-size: 30px;
  font-weight: 500;
  font-family: poppins;
  color: #0e0ed4;
}
.lightBlack {
  background-color: #4a4a4a !important;
}
.menuItem img {
  height: 18px;
}
.menuItem p {
  font-size: 14px;
  font-family: poppins;
  font-weight: 600;
}
.dropIcon {
  height: 10px;
}
.mainContainer {
  background-color: white;
  width: calc(100% - var(--sidebar-width));
  height: 100vh;
  transition: width 0.3s ease-in-out;
  overflow: auto;
}

.sidebarHidden + .mainContainer {
  width: 100%;
}
.subMenu {
  font-family: 10px;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  font-weight: 600;
  opacity: 0.7;
}
.subMenu i {
  font-size: 6px;
  margin-right: 5px;
  position: relative;
  top: -3px;
}


@media screen and (max-width: 768px) {
  :root {
    --sidebar-width: 100%;
  }
  .sidebarMain {
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    z-index: 2;
  }
  .sidebarHidden {
    width: 0;
  }
  .sidebarVisible {
    width: 100%;
  }
}
.barIcon {
  height: 20px;
  filter: brightness(0) invert(1);
}
.topNavMain {
  background-color: red;
  height: 130px;
}
.navRightDiv img {
  height: 30px;
}
.textPrimary {
  color: #851504;
}
.notificationDiv p {
  font-size: 10px;
  background-color: red;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  text-align: center;
  color: white;
  font-weight: 500;
  position: relative;
  top: 15px;
  left: -10px;
}
.notificationDiv img {
  height: 28px;
  position: relative;
  top: 2px;
  filter: brightness(0) invert(1);
}
.notificationDiv {
  cursor: pointer;
}
.loginMain {
  width: 400px;
}
.bgGradient {
  background: linear-gradient(to bottom, skyblue, white);
}
.loginMain h3 {
  font-family: poppins;
}
.topCard {
  background: white;
}
.topCard img {
  height: 35px;
  filter: brightness(0) invert(1);
}
.topCard h2 {
  font-family: poppins;
  margin-bottom: 0px;
}
.topCard h6 {
  font-family: sans-serif;
  font-weight: 600;
  margin-bottom: 0px;
}
.borderRadius24 {
  border-radius: 24px;
}
.borderRadius16 {
  border-radius: 16px;
}

.topActionForm input,
select,
button {
  height: 45px;
}
.table > :not(caption) > * > * {
  padding: 1.5rem 0.5rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}
.noRecordFoundMain {
  height: 75vh;
  background-color: #353535;
  border-radius: 20px;
}
.noRecordFoundInner {
  width: 800px;
  white-space: wrap;
  text-align: center;
}
.noRecordFoundInner h1 {
  margin-bottom: 80px;
  font-size: 50px;
  font-family: "poppins";
}
.noRecordFoundInner p {
  font-family: "sans-sirf";
  font-size: 30px;
}
.driverApprovalMain input:checked {
  height: 30px;
  font-size: 30px;
}
.chatBox {
  height: 65vh;
  background-color: #f5f5f5;
  border-radius: 30px;
  position: relative;
  overflow: scroll;
}
.bottomChatAction {
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  margin: 0px 5px;
  background: #fff;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 24px;
}
.bottomChatAction img{
  height: 30px;
}
.bottomChatAction input{
  border: none;
  outline: none;
  border-radius: 24px 0px 0px 24px;
}
.bottomChatAction button{
  height: 40px;
  border-radius: 0px 24px 24px 0px;
}

td ul {
  max-height: 150px;
  overflow-y: auto;
}
td ul li {
  font-size: 14px;
  border: 1px solid #ddd;
}
.orderMainCard{
  background-color: gainsboro;
  border-radius: 20px;
}

.flatCart p{
  margin-bottom: 0px;
  font-size: 13px;
  font-family: "poppins";
}
.boxCart{
  border-radius: 12px;
}
.boxCart p{
 margin-bottom: 4px;
  font-size: 14px;
  font-family: "poppins";
}
.boxCart b{
  color: #363435;
}
.lightGreenBg{
  background-color: #c34b36;
}

.custom-pagination .page-item .page-link {
  background-color: #f0f0f0;
  color: #000;
  border: none;
  margin: 0 5px;
  border-radius: 6px;
  min-width: 44px;
  text-align: center;
}

.custom-pagination .page-item.active .page-link {
  background-color: #333;
  color: #fff;
}

.custom-pagination .page-item.disabled .page-link {
  color: #828282;
  pointer-events: none;
  background-color: #f0f0f0;
}

.custom-select {
  border-radius: 6px;
  background-color: #f0f0f0;
  border: none;
  color: #000;
}

.order-tracker {
  list-style: none;
  padding-left: 0;
  margin-left: 15px;
  position: relative;
}

.order-tracker li {
  position: relative;
  margin-bottom: 30px;
  padding-left: 40px;
}

.order-tracker li:not(:last-child)::before {
  content: '';
  position: absolute;
  left: 0;
  top: 32px;
  bottom: -30px;
  width: 2px;
  border-left: 2px dashed #ccc;
  z-index: 0;
}

.order-tracker li .icon {
  position: absolute;
  left: -16px;
  top: 0;
  width: 32px;
  height: 32px;
  background: #e0f7fa;
  color: #0d6efd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border: 2px solid #0d6efd;
  z-index: 1;
}


.order-tracker li.completed .icon {
  background-color: #d1f7d6;
  color: #28a745;
  border-color: #28a745;
}

.order-tracker li.pending .icon {
  background-color: #f0f0f0;
  color: #999;
  border-color: #ddd;
}

.order-tracker li .details {
  margin-left: 10px;
}


.order-tracker li.active .icon {
  background-color: #e0f7fa;
  color: #0d6efd;
  border-color: #0d6efd;
}



.productDetailsDiv h1{
  font-family: poppins;
  font-size: 30px;
  font-weight: 600;
  color:gray
}
.reviewDiv a{
  font-family: sans-serif;
}
.productDetailsDiv h5{
  font-family: poppins;
  font-size: 16px;
  font-weight: 500;
}
.varientDiv span{
  border: 1px solid green;
  border-radius: 2px;
  font-family: sans-serif;
}
.counterDiv p{
  font-family: 16px;
  font-family: monospace;
  border: 1px solid gray;
  text-align: center;
  padding: 8px 14px;
  border-radius: 2px;
  margin-right: 6px;
  color: gray;
}
.productDetailsBtn button{
  width: 48%;
  background-color: #3d9970;
  padding: 8px 0px;
  font-family: poppins;
  border: none;
  border-radius: 6px;
  color: white;
}
.productDetailsLeftBtnGroup p{
  font-family: 16px;
  font-family: poppins;
  border: 1px solid gray;
  text-align: center;
  padding: 8px 14px;
  border-radius: 2px;
  width: 200px;
  color: gray;
  margin-bottom: 0px;
  cursor: pointer;
}
.breadcrumb p{
  font-family: poppins;
  margin-right: 8px;
}
.discountedPrice{
   font-size: 25px;
   color: #00b33c;
}
@media (max-width: 500px) {
  .productDetailsDiv h1{

  font-size: 16px;
  
}
.counterDiv p{
  font-family: 10px;
  
  padding: 3px 10px;
  border-radius: 2px;
  margin-right: 4px;
  color: gray;
}
.varientDiv span{
  font-size: 12px;
}
.row {
    
    margin-left: 0px !important;
    margin-right: 0px !important
}
.breadcrumb p{
  font-size: 11px;
  margin-bottom: 0px;
}
.productDetailsDiv h5{
  
  font-size: 12px;
  
}
.productDetailsBtn button{
  
  padding: 6px 0px;
  
  border-radius: 4px;
  
}
.discountedPrice{
   font-size: 16px;
   color: #00b33c;
}
.productDetailsLeftBtnGroup p{
  font-size: 10px !important;
  padding: 4px 7px;
  border-radius: 2px;
  width: 100px;
}
}
.productDetailsDiv h4{
   font-family: poppins;
  font-size: 16px;
  font-weight: 500;
  margin: 10px 0px;
  color: gray;
}
.productDetailsDiv h3{
   font-family: poppins;
  font-size: 30px;
  font-weight: 500;
  margin: 10px 0px;
  color: black;
}
select.form-control {
  appearance: auto;
  -webkit-appearance: auto;
  -moz-appearance: auto;
}

.starGroup img{
height: 20px !important;
margin-right: 5px;
}
.reviewBox img{
  height: 50px;
}
.reviewBox{
  border-radius: 12px;
  border: 1px solid gray;
  background-color: whitesmoke;
}

.custom-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.custom-modal-content {
  background: #fff;
  border-radius: 16px;
  padding: 30px;
  max-width: 960px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  position: relative;
  animation: zoomIn 0.3s ease;
}

.custom-scroll-area {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 8px;
}


@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale(0.85);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.table-container-with-sticky-header {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 8px;
  position: relative;
}

.table-container-with-sticky-header thead th {
  position: sticky;
  top: 0;
  background-color: #f8f9fa; 
  z-index: 2;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
}

.form-select option:disabled {
  color: #999;
}


.combo-product-list {
  max-height: none !important;
  overflow: visible !important;
  padding-left: 15px;
}

@media print {
  .combo-product-list {
    list-style: disc !important;
    font-size: 12px;
    line-height: 1.4;
  }
}



@media print {
  .print-area {
    overflow: visible !important;
    height: auto !important;
    max-height: none !important;
  }
  .bodyContainer,
  .mainContainer,
  .card {
    overflow: visible !important;
  }
}
 */

 /* ─── SIDEBAR VARIABLES ─────────────────────────────── */
/* ─── SIDEBAR VARIABLES ─────────────────────────────── */

:root {
  --sidebar-width: 260px;
  --sb-bg:         #1c0a0a;
  --sb-accent:     #a60808;
  --sb-accent-lt:  rgba(192, 57, 43, 0.14);
  --sb-border:     rgba(255, 255, 255, 0.06);
  --sb-text:       rgba(255, 255, 255, 0.52);
  --sb-text-hi:    rgba(255, 255, 255, 0.88);
  --sb-icon-bg:    rgba(255, 255, 255, 0.07);
}

/* ─── SIDEBAR SHELL ─────────────────────────────────── */
.sidebarMain {
  width: var(--sidebar-width);
  background-color: var(--sb-bg);
  height: 100vh;
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease-in-out;
  overflow: hidden;
  font-family: 'Segoe UI', sans-serif;
}
.sidebarHidden  { width: 0; }
.sidebarVisible { width: var(--sidebar-width); }

/* ─── HEADER / LOGO ─────────────────────────────────── */
.sb-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 22px 20px 18px;
  border-bottom: 1px solid var(--sb-border);
  flex-shrink: 0;
}
.sb-logo-box {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: var(--sb-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}
.sb-logo-img {
  height: 30px;
  width: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
}
.sb-brand-name {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.3px;
}
.sb-brand-sub {
  color: rgba(255, 255, 255, 0.28);
  font-size: 10px;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-top: 1px;
}

/* ─── SCROLLABLE NAV AREA ───────────────────────────── */
.sb-nav-area {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px 10px 10px;
  scrollbar-width: none;
}
.sb-nav-area::-webkit-scrollbar { display: none; }

/* ─── SECTION LABELS ────────────────────────────────── */
.sb-section-label {
  font-size: 11px;
  color: rgb(255 255 255 / 88%);
  text-transform: uppercase;
  letter-spacing: 1.3px;
  font-weight: 600;
  padding: 14px 8px 5px;
}

/* ─── MENU HEADER ROW ───────────────────────────────── */
.sb-menu-group { margin-bottom: 1px; }

.sb-menu-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border-radius: 9px;
  cursor: pointer;
  color: var(--sb-text);
  font-size: 14px;
  font-weight: 500;
  transition: background 0.18s, color 0.18s;
  -webkit-user-select: none;
          user-select: none;
}
.sb-menu-header:hover {
  background: rgba(255, 255, 255, 0.05);
  color: var(--sb-text-hi);
}
.sb-menu-header.active {
  background: var(--sb-accent-lt);
  color: #e8604c;
}

/* ─── ICON BOX ──────────────────────────────────────── */
.sb-icon-box {
  width: 30px;
  height: 30px;
  border-radius: 7px;
  background: var(--sb-icon-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  flex-shrink: 0;
  transition: background 0.18s, color 0.18s;
}
.sb-menu-header:hover .sb-icon-box {
  background: rgba(255, 255, 255, 0.1);
}
.sb-menu-header.active .sb-icon-box {
  background: var(--sb-accent);
  color: #fff;
}

.sb-menu-label { flex: 1 1; }

/* ─── CHEVRON ARROW ─────────────────────────────────── */
.sb-arrow {
  font-size: 11px;
  transition: transform 0.2s;
  opacity: 0.5;
}
.sb-arrow.open { transform: rotate(90deg); }

/* ─── SUBMENU ────────────────────────────────────────── */
.sb-submenu {
  padding: 3px 0 4px 50px;
}
.sb-sub-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border-radius: 7px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.4);
  font-size: 13.5px;
  transition: background 0.15s, color 0.15s;
  margin-bottom: 1px;
}
.sb-sub-item:hover {
  color: rgba(255, 255, 255, 0.78);
  background: rgba(255, 255, 255, 0.04);
}
.sb-sub-item.active {
  color: #e8604c;
  background: rgba(192, 57, 43, 0.12);
  font-weight: 500;
}
.sb-sub-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
  opacity: 0.65;
}
.sb-sub-item.active .sb-sub-dot { opacity: 1; }

/* ─── FOOTER ─────────────────────────────────────────── */
.sb-footer {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-top: 1px solid var(--sb-border);
  flex-shrink: 0;
}
.sb-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--sb-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}
.sb-user-info { flex: 1 1; }
.sb-user-name {
  color: rgba(255, 255, 255, 0.82);
  font-size: 13px;
  font-weight: 500;
}
.sb-user-role {
  color: rgba(255, 255, 255, 0.28);
  font-size: 11px;
}
.sb-logout {
  color: rgba(255, 255, 255, 0.25);
  font-size: 17px;
  cursor: pointer;
  transition: color 0.18s;
}
.sb-logout:hover { color: #e8604c; }

/* ─── MOBILE CLOSE BUTTON ───────────────────────────── */
.sb-close-btn {
  background: rgba(255, 255, 255, 0.08);
  border: none;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.6);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.18s;
}
.sb-close-btn:hover { background: rgba(255, 255, 255, 0.14); }

/* ─── MAIN CONTAINER (unchanged logic) ─────────────── */
.bodyContainer {
  height: 100vh;
  display: flex;
}
.mainContainer {
  background-color: white;
  width: calc(100% - var(--sidebar-width));
  height: 100vh;
  transition: width 0.3s ease-in-out;
  overflow: auto;
}
.sidebarHidden + .mainContainer { width: 100%; }

/* ─── MOBILE ─────────────────────────────────────────── */
@media screen and (max-width: 768px) {
  :root { --sidebar-width: 100%; }
  .sidebarMain {
    position: absolute;
    top: 0; left: 0;
    height: 100vh;
    width: 100%;
    z-index: 2;
  }
  .sidebarHidden  { width: 0; }
  .sidebarVisible { width: 100%; }
}

/* ═══════════════════════════════════════════════════════
   EXISTING STYLES BELOW — unchanged
   ═══════════════════════════════════════════════════════ */

/* ─── TOP NAV ────────────────────────────────────────── */
.topNavMain {
  background: #fff;
  border-bottom: 1px solid #f0eded;
  height: 64px;
  display: flex;
  align-items: start;
  padding: 0;
  flex-shrink: 0;
  padding-top: 20px;
}
.tn-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 24px;
}
.tn-left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.tn-hamburger {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background: #fdf2f1;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #a60808;
  font-size: 18px;
  transition: background 0.18s;
  flex-shrink: 0;
}
.tn-hamburger:hover { background: #f9e0dd; }
.tn-page-title {
  font-size: 17px;
  font-weight: 600;
  color: #1c0a0a;
  line-height: 1.2;
}
.tn-page-path {
  font-size: 13px;
  color: #828282;
  margin-top: 1px;
}
.tn-right {
  display: flex;
  align-items: center;
  gap: 6px;
}
.tn-icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background: #fdf2f1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  color: #a60808;
  font-size: 18px;
  transition: background 0.18s;
}
.tn-icon-btn:hover { background: #f9e0dd; }
.tn-badge {
  position: absolute;
  top: 7px;
  right: 7px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #a60808;
  border: 2px solid #fff;
}
.tn-divider {
  width: 1px;
  height: 28px;
  background: #f0eded;
  margin: 0 6px;
}
.tn-user-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.18s;
}
.tn-user-chip:hover { background: #fdf2f1; }
.tn-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #a60808;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}
.tn-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.tn-user-name {
  font-size: 15px;
  font-weight: 500;
  color: #1c0a0a;
  line-height: 1.2;
}
.tn-user-role {
  font-size: 13px;
  color: #828282;
}
.tn-logout-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #ccc;
  font-size: 17px;
  transition: background 0.18s, color 0.18s;
  margin-left: 2px;
}
.tn-logout-btn:hover { background: #fdf2f1; color: #a60808; }
@media screen and (max-width: 768px) {
  .tn-page-path { display: none; }
  .tn-user-text  { display: none; }
  .tn-inner { padding: 0 14px; }
}

.barIcon {
  height: 20px;
  filter: brightness(0) invert(1);
}
.topNavMain {
  /* background-color: red; */
  height: 100px;
}
.navRightDiv img { height: 30px; }
.textPrimary { color: #851504; }
.notificationDiv p {
  font-size: 10px;
  background-color: red;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  text-align: center;
  color: white;
  font-weight: 500;
  position: relative;
  top: 15px;
  left: -10px;
}
.notificationDiv img {
  height: 28px;
  position: relative;
  top: 2px;
  filter: brightness(0) invert(1);
}
.notificationDiv { cursor: pointer; }
.loginMain { width: 400px; }
.bgGradient { background: linear-gradient(to bottom, skyblue, white); }
.loginMain h3 { font-family: poppins; }
.topCard { background: white; }
.topCard img {
  height: 35px;
  filter: brightness(0) invert(1);
}
.topCard h2 { font-family: poppins; margin-bottom: 0px; }
.topCard h6 { font-family: sans-serif; font-weight: 600; margin-bottom: 0px; }
.borderRadius24 { border-radius: 24px; }
.borderRadius16 { border-radius: 16px; }
.topActionForm input,
select,
button { height: 45px; }
.table > :not(caption) > * > * {
  padding: 1.5rem 0.5rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}
.noRecordFoundMain {
  height: 75vh;
  background-color: #353535;
  border-radius: 20px;
}
.noRecordFoundInner {
  width: 800px;
  white-space: wrap;
  text-align: center;
}
.noRecordFoundInner h1 {
  margin-bottom: 80px;
  font-size: 50px;
  font-family: "poppins";
}
.noRecordFoundInner p {
  font-family: "sans-sirf";
  font-size: 30px;
}
.chatBox {
  height: 65vh;
  background-color: #f5f5f5;
  border-radius: 30px;
  position: relative;
  overflow: scroll;
}
.bottomChatAction {
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  margin: 0px 5px;
  background: #fff;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 24px;
}
.bottomChatAction img { height: 30px; }
.bottomChatAction input {
  border: none;
  outline: none;
  border-radius: 24px 0px 0px 24px;
}
.bottomChatAction button {
  height: 40px;
  border-radius: 0px 24px 24px 0px;
}
td ul { max-height: 150px; overflow-y: auto; }
td ul li { font-size: 14px; border: 1px solid #ddd; }
.orderMainCard { background-color: gainsboro; border-radius: 20px; }
.flatCart p { margin-bottom: 0px; font-size: 13px; font-family: "poppins"; }
.boxCart { border-radius: 12px; }
.boxCart p { margin-bottom: 4px; font-size: 14px; font-family: "poppins"; }
.boxCart b { color: #363435; }
.lightGreenBg { background-color: #c34b36; }
.custom-pagination .page-item .page-link {
  background-color: #f0f0f0;
  color: #000;
  border: none;
  margin: 0 5px;
  border-radius: 6px;
  min-width: 44px;
  text-align: center;
}
.custom-pagination .page-item.active .page-link {
  background-color: #333;
  color: #fff;
}
.custom-pagination .page-item.disabled .page-link {
  color: #828282;
  pointer-events: none;
  background-color: #f0f0f0;
}
.custom-select {
  border-radius: 6px;
  background-color: #f0f0f0;
  border: none;
  color: #000;
}
.order-tracker { list-style: none; padding-left: 0; margin-left: 15px; position: relative; }
.order-tracker li { position: relative; margin-bottom: 30px; padding-left: 40px; }
.order-tracker li:not(:last-child)::before {
  content: '';
  position: absolute;
  left: 0; top: 32px; bottom: -30px;
  width: 2px;
  border-left: 2px dashed #ccc;
  z-index: 0;
}
.order-tracker li .icon {
  position: absolute;
  left: -16px; top: 0;
  width: 32px; height: 32px;
  background: #e0f7fa;
  color: #0d6efd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border: 2px solid #0d6efd;
  z-index: 1;
}
.order-tracker li.completed .icon { background-color: #d1f7d6; color: #28a745; border-color: #28a745; }
.order-tracker li.pending .icon { background-color: #f0f0f0; color: #999; border-color: #ddd; }
.order-tracker li .details { margin-left: 10px; }
.order-tracker li.active .icon { background-color: #e0f7fa; color: #0d6efd; border-color: #0d6efd; }
.productDetailsDiv h1 { font-family: poppins; font-size: 30px; font-weight: 600; color: gray; }
.reviewDiv a { font-family: sans-serif; }
.productDetailsDiv h5 { font-family: poppins; font-size: 16px; font-weight: 500; }
.varientDiv span { border: 1px solid green; border-radius: 2px; font-family: sans-serif; }
.counterDiv p {
  font-family: monospace;
  border: 1px solid gray;
  text-align: center;
  padding: 8px 14px;
  border-radius: 2px;
  margin-right: 6px;
  color: gray;
}
.productDetailsBtn button {
  width: 48%;
  background-color: #3d9970;
  padding: 8px 0px;
  font-family: poppins;
  border: none;
  border-radius: 6px;
  color: white;
}
.productDetailsLeftBtnGroup p {
  font-family: poppins;
  border: 1px solid gray;
  text-align: center;
  padding: 8px 14px;
  border-radius: 2px;
  width: 200px;
  color: gray;
  margin-bottom: 0px;
  cursor: pointer;
}
.breadcrumb p { font-family: poppins; margin-right: 8px; }
.discountedPrice { font-size: 25px; color: #00b33c; }
@media (max-width: 500px) {
  .productDetailsDiv h1 { font-size: 16px; }
  .counterDiv p { padding: 3px 10px; border-radius: 2px; margin-right: 4px; color: gray; }
  .varientDiv span { font-size: 12px; }
  .row { margin-left: 0px !important; margin-right: 0px !important; }
  .breadcrumb p { font-size: 11px; margin-bottom: 0px; }
  .productDetailsDiv h5 { font-size: 12px; }
  .productDetailsBtn button { padding: 6px 0px; border-radius: 4px; }
  .discountedPrice { font-size: 16px; color: #00b33c; }
  .productDetailsLeftBtnGroup p { font-size: 10px !important; padding: 4px 7px; border-radius: 2px; width: 100px; }
}
.productDetailsDiv h4 { font-family: poppins; font-size: 16px; font-weight: 500; margin: 10px 0px; color: gray; }
.productDetailsDiv h3 { font-family: poppins; font-size: 30px; font-weight: 500; margin: 10px 0px; color: black; }
select.form-control { appearance: auto; -webkit-appearance: auto; -moz-appearance: auto; }
.starGroup img { height: 20px !important; margin-right: 5px; }
.reviewBox img { height: 50px; }
.reviewBox { border-radius: 12px; border: 1px solid gray; background-color: whitesmoke; }
.custom-modal-backdrop {
  position: fixed;
  top: 0; left: 0;
  height: 100vh; width: 100vw;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
.custom-modal-content {
  background: #fff;
  border-radius: 16px;
  padding: 30px;
  max-width: 960px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  position: relative;
  animation: zoomIn 0.3s ease;
}
.custom-scroll-area { max-height: 400px; overflow-y: auto; border: 1px solid #ddd; border-radius: 8px; }
@keyframes zoomIn {
  from { opacity: 0; transform: scale(0.85); }
  to   { opacity: 1; transform: scale(1); }
}
.table-container-with-sticky-header {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 8px;
  position: relative;
}
.table-container-with-sticky-header thead th {
  position: sticky;
  top: 0;
  background-color: #f8f9fa;
  z-index: 2;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
}
.form-select option:disabled { color: #999; }
.combo-product-list { max-height: none !important; overflow: visible !important; padding-left: 15px; }
@media print {
  .combo-product-list { list-style: disc !important; font-size: 12px; line-height: 1.4; }
  .print-area { overflow: visible !important; height: auto !important; max-height: none !important; }
  .bodyContainer, .mainContainer, .card { overflow: visible !important; }
}


/* ═══════════════════════════════════════════════════════════
   adminForm.css
   Shared design system for all admin Add / Update form pages
   Theme: DM Sans · Red #a60808 · Dark #1c0a0a · Bg #f5f5f7
   ═══════════════════════════════════════════════════════════ */


/* ── Page wrapper ───────────────────────────────────────── */
.af-page {
  background: #f5f5f7;
  min-height: 100%;
  padding: 28px;
  font-family: 'DM Sans', 'Segoe UI', sans-serif;
  font-size: 15px;
}

/* ── Page header ────────────────────────────────────────── */
.af-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 22px;
  flex-wrap: wrap;
  gap: 12px;
}
.af-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.af-back-btn {
  width: 40px;
  height: 40px;
  border-radius: 11px;
  border: 1px solid #f0eded;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #555;
  cursor: pointer;
  transition: all 0.18s;
  flex-shrink: 0;
}
.af-back-btn:hover { background: #fdf2f1; color: #a60808; border-color: #f0c0b8; }

.af-page-title {
  font-size: 22px;
  font-weight: 700;
  color: #1c0a0a;
  letter-spacing: -0.4px;
}
.af-breadcrumb {
  font-size: 13px;
  color: #aaa;
  margin-top: 3px;
  font-weight: 500;
}
.af-breadcrumb span { color: #a60808; }

/* Header right badge (e.g. "Editing ID: XXXXXX" or step badge) */
.af-header-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: #fdf2f1;
  border: 1px solid #f0c0b8;
  border-radius: 10px;
  padding: 7px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #a60808;
}

/* Step badge variant */
.af-step-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #1c0a0a;
  border-radius: 10px;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.3px;
}
.af-step-badge .af-step-num {
  background: #a60808;
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 700;
}

/* ── Card ───────────────────────────────────────────────── */
.af-card {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #f0eded;
  padding: 28px 28px 32px;
  margin-bottom: 18px;
}

/* Section title inside card */
.af-section-title {
  font-size: 14px;
  font-weight: 700;
  color: #a60808;
  text-transform: uppercase;
  letter-spacing: 0.9px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.af-section-title::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: #f0eded;
}

/* ── Form grid ──────────────────────────────────────────── */
.af-grid   { display: grid; gap: 20px; }
.af-grid-1 { grid-template-columns: 1fr; }
.af-grid-2 { grid-template-columns: 1fr 1fr; }
.af-grid-3 { grid-template-columns: 1fr 1fr 1fr; }
.af-grid-4 { grid-template-columns: 1fr 1fr 1fr 1fr; }
@media (max-width: 900px) { .af-grid-3, .af-grid-4 { grid-template-columns: 1fr 1fr; } }
@media (max-width: 600px) { .af-grid-2, .af-grid-3, .af-grid-4 { grid-template-columns: 1fr; } }

/* ── Field ──────────────────────────────────────────────── */
.af-field { display: flex; flex-direction: column; gap: 7px; }

.af-label {
  font-size: 13.5px;
  font-weight: 600;
  color: #333;
  letter-spacing: 0.1px;
}
.af-label .af-req  { color: #a60808; margin-left: 2px; }
.af-label .af-hint { font-size: 12px; color: #aaa; font-weight: 400; margin-left: 5px; }

/* ── Inputs ─────────────────────────────────────────────── */
.af-input,
.af-select,
.af-textarea {
  height: 46px;
  border-radius: 11px;
  border: 1px solid #ede9e9;
  padding: 0 16px;
  font-size: 15px;
  color: #333;
  background: #fafafa;
  outline: none;
  font-family: 'DM Sans', sans-serif;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
  width: 100%;
  box-sizing: border-box;
}
.af-input:focus,
.af-select:focus,
.af-textarea:focus {
  border-color: #f0c0b8;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(192,57,43,0.07);
}
.af-input::placeholder,
.af-textarea::placeholder { color: #ccc; }
.af-input.af-error { border-color: #e74c3c; background: #fff8f8; }
.af-input:disabled,
.af-select:disabled { opacity: 0.55; cursor: not-allowed; }

.af-textarea {
  height: auto;
  padding: 14px 16px;
  resize: vertical;
  line-height: 1.6;
}

.af-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 14px center;
  background-color: #fafafa;
  padding-right: 38px;
  cursor: pointer;
}

/* Status select color variants */
.af-select.status-active   { border-color: #a8e6b0; background: #f2fdf4; color: #1e8449; }
.af-select.status-inactive { border-color: #f5d49a; background: #fefdf2; color: #b7770d; }

/* ── React-Select custom theme ──────────────────────────── */
.af-react-select .select__control {
  border-radius: 11px !important;
  border: 1px solid #ede9e9 !important;
  background: #fafafa !important;
  min-height: 46px !important;
  font-size: 15px !important;
  font-family: 'DM Sans', sans-serif !important;
  box-shadow: none !important;
  transition: border-color 0.15s, box-shadow 0.15s !important;
}
.af-react-select .select__control--is-focused {
  border-color: #f0c0b8 !important;
  background: #fff !important;
  box-shadow: 0 0 0 3px rgba(192,57,43,0.07) !important;
}
.af-react-select .select__multi-value {
  background: #fdf2f1 !important;
  border-radius: 6px !important;
}
.af-react-select .select__multi-value__label {
  color: #a60808 !important;
  font-size: 13px !important;
  font-weight: 600 !important;
}
.af-react-select .select__multi-value__remove:hover {
  background: #f0c0b8 !important;
  color: #a60808 !important;
}
.af-react-select .select__option--is-focused  { background: #fdf2f1 !important; }
.af-react-select .select__option--is-selected { background: #a60808 !important; color: #fff !important; }
.af-react-select .select__placeholder { color: #ccc !important; font-size: 15px !important; }
.af-react-select .select__menu {
  border-radius: 11px !important;
  border: 1px solid #f0eded !important;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08) !important;
  font-family: 'DM Sans', sans-serif !important;
  font-size: 15px !important;
}

/* ── Banner / Image upload ──────────────────────────────── */
.af-banner-wrap {
  border-radius: 12px;
  border: 2px dashed #ede9e9;
  overflow: hidden;
  background: #fafafa;
  transition: border-color 0.18s;
  cursor: pointer;
}
.af-banner-wrap:hover { border-color: #f0c0b8; }
.af-banner-preview {
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: block;
}
.af-banner-placeholder {
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.af-banner-placeholder i { font-size: 38px; color: #e8d0cd; }
.af-banner-placeholder p { font-size: 14px; color: #bbb; font-weight: 500; margin: 0; }

.af-file-input {
  margin-top: 10px;
  width: 100%;
  font-size: 14px;
  font-family: 'DM Sans', sans-serif;
  color: #555;
}
.af-file-input::file-selector-button {
  height: 36px;
  border-radius: 9px;
  border: 1px solid #f0eded;
  background: #fff;
  padding: 0 16px;
  font-size: 13.5px;
  font-weight: 600;
  color: #a60808;
  cursor: pointer;
  margin-right: 12px;
  font-family: 'DM Sans', sans-serif;
  transition: background 0.15s;
}
.af-file-input::file-selector-button:hover { background: #fdf2f1; }

/* ── Jodit editor ───────────────────────────────────────── */
.jodit-container {
  border-radius: 11px !important;
  border: 1px solid #ede9e9 !important;
  font-size: 15px !important;
  overflow: hidden;
  font-family: 'DM Sans', sans-serif !important;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.jodit-container:focus-within {
  border-color: #f0c0b8 !important;
  box-shadow: 0 0 0 3px rgba(192,57,43,0.07) !important;
}
.jodit-toolbar__box {
  border-bottom: 1px solid #f0eded !important;
  background: #fafafa !important;
}
.jodit-wysiwyg {
  font-family: 'DM Sans', sans-serif !important;
  font-size: 15px !important;
  color: #333 !important;
  min-height: 160px !important;
}

/* ── Skeleton loader ────────────────────────────────────── */
.af-skeleton {
  background: linear-gradient(90deg, #f0eded 25%, #e8e4e4 50%, #f0eded 75%);
  background-size: 200% 100%;
  animation: af-shimmer 1.4s infinite;
  border-radius: 8px;
  height: 46px;
  width: 100%;
}
@keyframes af-shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Action bar (bottom) ────────────────────────────────── */
.af-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}
.af-required-note {
  font-size: 13px;
  color: #bbb;
  font-style: italic;
  margin-right: auto;
}
.af-required-note span { color: #a60808; }

.af-cancel-btn {
  height: 48px;
  padding: 0 28px;
  border-radius: 12px;
  border: 1px solid #ede9e9;
  background: #fff;
  font-size: 15px;
  font-weight: 600;
  color: #666;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  transition: all 0.18s;
}
.af-cancel-btn:hover { background: #f5f5f7; color: #333; }

.af-submit-btn {
  height: 48px;
  padding: 0 36px;
  border-radius: 12px;
  border: none;
  background: #a60808;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  letter-spacing: 0.2px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: background 0.18s, transform 0.1s, opacity 0.18s;
}
.af-submit-btn:hover:not(:disabled) { background: #a93226; transform: translateY(-1px); }
.af-submit-btn:active:not(:disabled) { transform: translateY(0); }
.af-submit-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* Next step button (dark) */
.af-next-btn {
  height: 48px;
  padding: 0 36px;
  border-radius: 12px;
  border: none;
  background: #a60808;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  letter-spacing: 0.2px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: background 0.18s, transform 0.1s, opacity 0.18s;
}
.af-next-btn:hover:not(:disabled) { background: #a60808; transform: translateY(-1px); }
.af-next-btn:active:not(:disabled) { transform: translateY(0); }
.af-next-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* Loader spin */
@keyframes af-spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
.af-spin { animation: af-spin 1s linear infinite; }

/* ── Error text ─────────────────────────────────────────── */
.af-error-msg {
  font-size: 12.5px;
  color: #e74c3c;
  margin-top: 4px;
  font-weight: 500;
}

/* ── Info/helper text below field ───────────────────────── */
.af-helper {
  font-size: 12px;
  color: #bbb;
  margin-top: 2px;
}
























/* common css for list pages  */


  .pl-root {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'DM Sans', 'Segoe UI', sans-serif;
  }

  /* ── Stat grid ── */
  .pl-stat-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    margin-bottom: 22px;
  }
  @media (max-width: 900px)  { .pl-stat-grid { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 560px)  { .pl-stat-grid { grid-template-columns: 1fr; } }

  .pl-stat-card {
    background: #fff;
    border-radius: 14px;
    padding: 18px 20px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .pl-stat-icon {
    width: 46px; height: 46px;
    border-radius: 12px;
    background: #fdf2f1;
    display: flex; align-items: center; justify-content: center;
    font-size: 22px;
    color: #a60808;
    flex-shrink: 0;
  }
  .pl-stat-val {
    font-size: 26px;
    font-weight: 700;
    color: #1c0a0a;
    line-height: 1;
    font-family: 'JetBrains Mono', monospace;
  }
  .pl-stat-lbl {
    font-size: 14px;
    color: #828282;
    margin-top: 5px;
    font-weight: 500;
  }

  /* ── Toolbar ── */
  .pl-toolbar {
    background: #fff;
    border-radius: 14px;
    padding: 18px 22px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
  }
  .pl-toolbar-title {
    font-size: 20px;
    font-weight: 700;
    color: #1c0a0a;
    margin-right: auto;
  }

  .pl-input {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 14px;
    color: #444;
    background: #f9f9f9;
    outline: none;
    min-width: 170px;
    font-family: 'DM Sans', sans-serif;
  }
  .pl-input:focus { border-color: #f0c0b8; }
  .pl-input::placeholder { color: #bbb; }

  .pl-select {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 14px;
    color: #555;
    background: #f9f9f9;
    outline: none;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
  }
  .pl-select:focus { border-color: #f0c0b8; }

  /* buttons */
  .pl-btn {
    height: 40px;
    padding: 0 18px;
    border-radius: 10px;
    border: none;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 7px;
    white-space: nowrap;
    transition: all 0.18s;
    font-family: 'DM Sans', sans-serif;
  }
  .pl-btn-red    { background: #a60808; color: #fff; }
  .pl-btn-red:hover    { background: #a93226; }
  .pl-btn-dark   { background: #1c0a0a; color: #fff; }
  .pl-btn-dark:hover   { background: #2e1010; }
  .pl-btn-blue   { background: #2980b9; color: #fff; }
  .pl-btn-blue:hover   { background: #2471a3; }
  .pl-btn-danger { background: #fdecea; color: #a60808; border: 1px solid #f0c0b8; }
  .pl-btn-danger:hover:not(:disabled) { background: #fbd5d1; }
  .pl-btn-danger:disabled { opacity: 0.45; cursor: default; }

  /* download dropdown */
  .pl-download-wrap { position: relative; }
  .pl-dropdown-menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    background: #fff;
    border: 1px solid #f0eded;
    border-radius: 10px;
    padding: 6px;
    z-index: 200;
    min-width: 200px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.09);
  }
  .pl-dropdown-divider { height: 1px; background: #f0eded; margin: 5px 0; }
  .pl-dropdown-item {
    display: block; width: 100%;
    padding: 9px 14px;
    font-size: 14px;
    color: #444; background: none; border: none;
    border-radius: 7px; text-align: left; cursor: pointer;
    font-family: 'DM Sans', sans-serif;
  }
  .pl-dropdown-item:hover { background: #fdf2f1; color: #a60808; }
  .pl-dropdown-label {
    font-size: 11px; font-weight: 700; color: #bbb;
    text-transform: uppercase; letter-spacing: 0.6px;
    padding: 6px 14px 3px;
  }

  /* ── Table card ── */
  .pl-table-wrap {
    background: #fff;
    border-radius: 14px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }
  .pl-table-scroll { overflow-x: auto; }
  .pl-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 15px;
  }
  .pl-table thead tr { background: #fdf2f1; }
  .pl-table th {
    padding: 14px 16px;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    color: #a60808;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    white-space: nowrap;
  }
  .pl-table th.center,
  .pl-table td.center { text-align: center; }
  .pl-table td {
    padding: 14px 16px;
    color: #444;
    border-top: 1px solid #f7f5f5;
    vertical-align: middle;
    font-size: 15px;
  }
  .pl-table tbody tr:hover td { background: #fdfafa; }

  /* checkbox */
  .pl-check {
    width: 16px; height: 16px;
    accent-color: #a60808;
    cursor: pointer;
  }
  .pl-check-label {
    display: flex; align-items: center; gap: 7px;
    font-size: 13px; color: #888; cursor: pointer;
    white-space: nowrap;
  }

  /* product cell */
  .pl-prod-cell { display: flex; align-items: center; gap: 12px; }
  .pl-prod-img {
    width: 48px; height: 48px;
    border-radius: 10px;
    object-fit: cover;
    border: 1px solid #f0eded;
    background: #fdf2f1;
    flex-shrink: 0;
  }
  .pl-prod-name {
    font-size: 15px; font-weight: 600; color: #1c0a0a;
    max-width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }

  /* category chip */
  .pl-cat-chip {
    display: inline-block;
    font-size: 12px; font-weight: 600;
    background: #fdf2f1; color: #a60808;
    padding: 3px 10px; border-radius: 20px;
    border: 1px solid #f0c0b8;
  }

  /* price */
  .pl-price-main {
    font-size: 16px; font-weight: 700; color: #1c0a0a;
    font-family: 'JetBrains Mono', monospace;
  }
  .pl-price-strike {
    font-size: 13px; color: #bbb;
    text-decoration: line-through;
    font-family: 'JetBrains Mono', monospace;
    margin-top: 2px;
  }

  /* stock badge */
  .pl-stock {
    display: inline-flex; align-items: center;
    font-size: 14px; font-weight: 600;
    font-family: 'JetBrains Mono', monospace;
    color: #1c0a0a;
  }

  /* status badge */
  .pl-badge {
    display: inline-flex; align-items: center; gap: 5px;
    font-size: 12.5px; font-weight: 700;
    padding: 4px 12px; border-radius: 20px;
    cursor: pointer; transition: opacity 0.15s;
  }
  .pl-badge:hover { opacity: 0.8; }
  .pl-badge.active { background: #e8f8ef; color: #27ae60; border: 1px solid #b7e4c7; }
  .pl-badge.inactive { background: #fff5e6; color: #e67e22; border: 1px solid #fcd9a0; }

  /* view btn */
  .pl-view-btn {
    height: 34px; padding: 0 16px;
    border-radius: 9px;
    border: 1px solid #f0eded; background: #fff;
    font-size: 14px; color: #555;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    transition: all 0.18s;
    font-family: 'DM Sans', sans-serif;
  }
  .pl-view-btn:hover { background: #fdf2f1; border-color: #f0c0b8; color: #a60808; }

  /* sr no */
  .pl-sr { font-size: 13px; color: #bbb; font-family: 'JetBrains Mono', monospace; }

  /* skeleton */
  .pl-skel-cell { padding: 14px 16px; border-top: 1px solid #f7f5f5; }

  /* pagination */
  .pl-pagination {
    display: flex; align-items: center; justify-content: space-between;
    flex-wrap: wrap; gap: 12px;
    padding: 16px 22px;
    border-top: 1px solid #f7f5f5;
  }
  .pl-show-row { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #888; }
  .pl-page-btns { display: flex; align-items: center; gap: 5px; }
  .pl-pg-btn {
    width: 36px; height: 36px;
    border-radius: 9px;
    border: 1px solid #f0eded; background: #fff;
    font-size: 14px; color: #555;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: all 0.18s;
    font-family: 'DM Sans', sans-serif;
  }
  .pl-pg-btn.active { background: #a60808; color: #fff; border-color: #a60808; }
  .pl-pg-btn:hover:not(.active):not(:disabled) { background: #fdf2f1; color: #a60808; }
  .pl-pg-btn:disabled { opacity: 0.4; cursor: default; }

  /* ── Modal ── */
  .pl-modal-overlay {
    position: fixed; inset: 0;
    background: rgba(28,10,10,0.45);
    display: flex; align-items: center; justify-content: center;
    z-index: 1050;
  }
  .pl-modal {
    background: #fff;
    border-radius: 18px;
    width: 400px;
    max-width: 95vw;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0,0,0,0.18);
    font-family: 'DM Sans', sans-serif;
  }
  .pl-modal-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 20px 24px 16px;
    border-bottom: 1px solid #f0eded;
  }
  .pl-modal-title { font-size: 17px; font-weight: 700; color: #1c0a0a; }
  .pl-modal-close {
    width: 32px; height: 32px;
    border-radius: 8px; border: 1px solid #f0eded;
    background: #f9f9f9; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    color: #888; font-size: 16px; transition: all 0.15s;
  }
  .pl-modal-close:hover { background: #fdf2f1; color: #a60808; border-color: #f0c0b8; }
  .pl-modal-body { padding: 22px 24px; }
  .pl-modal-footer { padding: 16px 24px; border-top: 1px solid #f0eded; display: flex; justify-content: flex-end; gap: 10px; }

  .pl-field-label {
    font-size: 12px; font-weight: 700; color: #888;
    text-transform: uppercase; letter-spacing: 0.5px;
    margin-bottom: 6px; display: block;
  }
  .pl-field-input {
    width: 100%;
    height: 42px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 15px;
    color: #1c0a0a;
    background: #f9f9f9;
    outline: none;
    font-family: 'DM Sans', sans-serif;
    margin-bottom: 14px;
  }
  .pl-field-input:focus { border-color: #f0c0b8; }
  .pl-field-input[readonly] { color: #999; }

  .pl-preview-img {
    width: 100%; height: 180px;
    object-fit: contain;
    border-radius: 10px;
    border: 1px solid #f0eded;
    background: #f9f9f9;
    margin-bottom: 16px;
  }
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAykBE;;CAED,0DAA0D;AAC3D,0DAA0D;;AAK1D;EACE,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,wCAAwC;EACxC,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA,0DAA0D;AAC1D;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;EAChB,mCAAmC;AACrC;AACA,kBAAkB,QAAQ,EAAE;AAC5B,kBAAkB,2BAA2B,EAAE;;AAE/C,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;AACA,kCAAkC,aAAa,EAAE;;AAEjD,0DAA0D;AAC1D;EACE,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,0DAA0D;AAC1D,iBAAiB,kBAAkB,EAAE;;AAErC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,qCAAqC;EACrC,wBAAwB;AAC1B;AACA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,oCAAoC;AACtC;AACA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA,iBAAiB,SAAO,EAAE;;AAE1B,0DAA0D;AAC1D;EACE,eAAe;EACf,0BAA0B;EAC1B,YAAY;AACd;AACA,iBAAiB,wBAAwB,EAAE;;AAE3C,2DAA2D;AAC3D;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;EACd,aAAa;AACf;AACA,kCAAkC,UAAU,EAAE;;AAE9C,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,gBAAgB,SAAO,EAAE;AACzB;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;AACA,mBAAmB,cAAc,EAAE;;AAEnC,0DAA0D;AAC1D;EACE,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;AACA,sBAAsB,qCAAqC,EAAE;;AAE7D,yDAAyD;AACzD;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,aAAa;EACb,kCAAkC;EAClC,cAAc;AAChB;AACA,kCAAkC,WAAW,EAAE;;AAE/C,2DAA2D;AAC3D;EACE,QAAQ,qBAAqB,EAAE;EAC/B;IACE,kBAAkB;IAClB,MAAM,EAAE,OAAO;IACf,aAAa;IACb,WAAW;IACX,UAAU;EACZ;EACA,kBAAkB,QAAQ,EAAE;EAC5B,kBAAkB,WAAW,EAAE;AACjC;;AAEA;;4DAE4D;;AAE5D,2DAA2D;AAC3D;EACE,gBAAgB;EAChB,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;AACA,sBAAsB,mBAAmB,EAAE;AAC3C;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;AACA,qBAAqB,mBAAmB,EAAE;AAC1C;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;AACA,sBAAsB,mBAAmB,EAAE;AAC3C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,eAAe;EACf,yCAAyC;EACzC,gBAAgB;AAClB;AACA,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D;EACE,gBAAgB,aAAa,EAAE;EAC/B,iBAAiB,aAAa,EAAE;EAChC,YAAY,eAAe,EAAE;AAC/B;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,2BAA2B;EAC3B,aAAa;AACf;AACA,mBAAmB,YAAY,EAAE;AACjC,eAAe,cAAc,EAAE;AAC/B;EACE,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;AACjC;AACA,mBAAmB,eAAe,EAAE;AACpC,aAAa,YAAY,EAAE;AAC3B,cAAc,sDAAsD,EAAE;AACtE,gBAAgB,oBAAoB,EAAE;AACtC,WAAW,iBAAiB,EAAE;AAC9B;EACE,YAAY;EACZ,+BAA+B;AACjC;AACA,cAAc,oBAAoB,EAAE,kBAAkB,EAAE;AACxD,cAAc,uBAAuB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC7E,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,mBAAmB,EAAE;AACvC;;SAES,YAAY,EAAE;AACvB;EACE,sBAAsB;EACtB,oCAAoC;EACpC,wBAAwB;EACxB,wDAAwD;AAC1D;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;AACrB;AACA,wBAAwB,YAAY,EAAE;AACtC;EACE,YAAY;EACZ,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,gCAAgC;AAClC;AACA,QAAQ,iBAAiB,EAAE,gBAAgB,EAAE;AAC7C,WAAW,eAAe,EAAE,sBAAsB,EAAE;AACpD,iBAAiB,2BAA2B,EAAE,mBAAmB,EAAE;AACnE,cAAc,kBAAkB,EAAE,eAAe,EAAE,sBAAsB,EAAE;AAC3E,WAAW,mBAAmB,EAAE;AAChC,aAAa,kBAAkB,EAAE,eAAe,EAAE,sBAAsB,EAAE;AAC1E,aAAa,cAAc,EAAE;AAC7B,gBAAgB,yBAAyB,EAAE;AAC3C;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;AACA,iBAAiB,gBAAgB,EAAE,eAAe,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAC3F,oBAAoB,kBAAkB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACjF;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,SAAS,EAAE,aAAa;EACjC,UAAU;EACV,4BAA4B;EAC5B,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW,EAAE,MAAM;EACnB,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;AACA,oCAAoC,yBAAyB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACtG,kCAAkC,yBAAyB,EAAE,WAAW,EAAE,kBAAkB,EAAE;AAC9F,6BAA6B,iBAAiB,EAAE;AAChD,iCAAiC,yBAAyB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACnG,wBAAwB,oBAAoB,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;AAC9F,eAAe,uBAAuB,EAAE;AACxC,wBAAwB,oBAAoB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACjF,mBAAmB,uBAAuB,EAAE,kBAAkB,EAAE,uBAAuB,EAAE;AACzF;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA,gBAAgB,oBAAoB,EAAE,iBAAiB,EAAE;AACzD,mBAAmB,eAAe,EAAE,cAAc,EAAE;AACpD;EACE,wBAAwB,eAAe,EAAE;EACzC,gBAAgB,iBAAiB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,WAAW,EAAE;EACvF,mBAAmB,eAAe,EAAE;EACpC,OAAO,2BAA2B,EAAE,4BAA4B,EAAE;EAClE,gBAAgB,eAAe,EAAE,kBAAkB,EAAE;EACrD,wBAAwB,eAAe,EAAE;EACzC,4BAA4B,gBAAgB,EAAE,kBAAkB,EAAE;EAClE,mBAAmB,eAAe,EAAE,cAAc,EAAE;EACpD,gCAAgC,0BAA0B,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,YAAY,EAAE;AAClH;AACA,wBAAwB,oBAAoB,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,WAAW,EAAE;AAChH,wBAAwB,oBAAoB,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,YAAY,EAAE;AACjH,sBAAsB,gBAAgB,EAAE,wBAAwB,EAAE,qBAAqB,EAAE;AACzF,iBAAiB,uBAAuB,EAAE,iBAAiB,EAAE;AAC7D,iBAAiB,YAAY,EAAE;AAC/B,aAAa,mBAAmB,EAAE,sBAAsB,EAAE,4BAA4B,EAAE;AACxF;EACE,eAAe;EACf,MAAM,EAAE,OAAO;EACf,aAAa,EAAE,YAAY;EAC3B,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,2BAA2B;AAC7B;AACA,sBAAsB,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;AACvG;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,UAAU;EACV,2CAA2C;AAC7C;AACA,+BAA+B,WAAW,EAAE;AAC5C,sBAAsB,2BAA2B,EAAE,4BAA4B,EAAE,kBAAkB,EAAE;AACrG;EACE,sBAAsB,2BAA2B,EAAE,eAAe,EAAE,gBAAgB,EAAE;EACtF,cAAc,4BAA4B,EAAE,uBAAuB,EAAE,2BAA2B,EAAE;EAClG,wCAAwC,4BAA4B,EAAE;AACxE;;;AAGA;;;;gEAIgE;;;AAGhE,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,8CAA8C;EAC9C,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;AACA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;;AAEjF;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA,sBAAsB,cAAc,EAAE;;AAEtC,iEAAiE;AACjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D,aAAa,aAAa,EAAE,SAAS,EAAE;AACvC,aAAa,0BAA0B,EAAE;AACzC,aAAa,8BAA8B,EAAE;AAC7C,aAAa,kCAAkC,EAAE;AACjD,aAAa,sCAAsC,EAAE;AACrD,4BAA4B,yBAAyB,8BAA8B,EAAE,EAAE;AACvF,4BAA4B,qCAAqC,0BAA0B,EAAE,EAAE;;AAE/F,8DAA8D;AAC9D,YAAY,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAE7D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;AACA,qBAAqB,cAAc,EAAE,gBAAgB,EAAE;AACvD,qBAAqB,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAEvF,8DAA8D;AAC9D;;;EAGE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,kEAAkE;EAClE,WAAW;EACX,sBAAsB;AACxB;AACA;;;EAGE,qBAAqB;EACrB,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;4BAC4B,WAAW,EAAE;AACzC,qBAAqB,qBAAqB,EAAE,mBAAmB,EAAE;AACjE;sBACsB,aAAa,EAAE,mBAAmB,EAAE;;AAE1D;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yDAAwN;EACxN,4BAA4B;EAC5B,sCAAsC;EACtC,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,iCAAiC;AACjC,6BAA6B,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACzF,6BAA6B,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;;AAEzF,8DAA8D;AAC9D;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,6CAA6C;EAC7C,2BAA2B;EAC3B,2DAA2D;AAC7D;AACA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,qDAAqD;AACvD;AACA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA,gDAAgD,8BAA8B,EAAE;AAChF,gDAAgD,8BAA8B,EAAE,sBAAsB,EAAE;AACxG,wCAAwC,sBAAsB,EAAE,0BAA0B,EAAE;AAC5F;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,kDAAkD;EAClD,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;AACA,wBAAwB,qBAAqB,EAAE;AAC/C;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA,2BAA2B,eAAe,EAAE,cAAc,EAAE;AAC5D,2BAA2B,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE,SAAS,EAAE;;AAEtF;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,4BAA4B;AAC9B;AACA,6CAA6C,mBAAmB,EAAE;;AAElE,8DAA8D;AAC9D;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,0BAA0B;EAC1B,gBAAgB;EAChB,6CAA6C;EAC7C,gDAAgD;AAClD;AACA;EACE,gCAAgC;EAChC,qDAAqD;AACvD;AACA;EACE,2CAA2C;EAC3C,8BAA8B;AAChC;AACA;EACE,6CAA6C;EAC7C,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA,8DAA8D;AAC9D;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;AACA,yBAAyB,cAAc,EAAE;;AAEzC;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,qBAAqB;AACvB;AACA,uBAAuB,mBAAmB,EAAE,WAAW,EAAE;;AAEzD;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2DAA2D;AAC7D;AACA,sCAAsC,mBAAmB,EAAE,2BAA2B,EAAE;AACxF,uCAAuC,wBAAwB,EAAE;AACjE,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;;AAE7D,4BAA4B;AAC5B;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2DAA2D;AAC7D;AACA,oCAAoC,mBAAmB,EAAE,2BAA2B,EAAE;AACtF,qCAAqC,wBAAwB,EAAE;AAC/D,wBAAwB,YAAY,EAAE,mBAAmB,EAAE;;AAE3D,gBAAgB;AAChB;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;AACA,WAAW,qCAAqC,EAAE;;AAElD,8DAA8D;AAC9D;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;;;;;;;;;;;;;;;;;;;;;;;;AAyBA,+BAA+B;;;EAG7B;IACE,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,8CAA8C;EAChD;;EAEA,oBAAoB;EACpB;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;EACrB;EACA,6BAA6B,gBAAgB,oCAAoC,EAAE,EAAE;EACrF,6BAA6B,gBAAgB,0BAA0B,EAAE,EAAE;;EAE3E;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,WAAW,EAAE,YAAY;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;IAC3D,eAAe;IACf,cAAc;IACd,cAAc;EAChB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,wCAAwC;EAC1C;EACA;IACE,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA,kBAAkB;EAClB;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,kCAAkC;EACpC;EACA,kBAAkB,qBAAqB,EAAE;EACzC,yBAAyB,WAAW,EAAE;;EAEtC;IACE,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,kCAAkC;EACpC;EACA,mBAAmB,qBAAqB,EAAE;;EAE1C,YAAY;EACZ;IACE,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;IACnD,mBAAmB;IACnB,qBAAqB;IACrB,kCAAkC;EACpC;EACA,iBAAiB,mBAAmB,EAAE,WAAW,EAAE;EACnD,uBAAuB,mBAAmB,EAAE;EAC5C,iBAAiB,mBAAmB,EAAE,WAAW,EAAE;EACnD,uBAAuB,mBAAmB,EAAE;EAC5C,iBAAiB,mBAAmB,EAAE,WAAW,EAAE;EACnD,uBAAuB,mBAAmB,EAAE;EAC5C,iBAAiB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;EACjF,sCAAsC,mBAAmB,EAAE;EAC3D,0BAA0B,aAAa,EAAE,eAAe,EAAE;;EAE1D,sBAAsB;EACtB,oBAAoB,kBAAkB,EAAE;EACxC;IACE,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,uCAAuC;EACzC;EACA,uBAAuB,WAAW,EAAE,mBAAmB,EAAE,aAAa,EAAE;EACxE;IACE,cAAc,EAAE,WAAW;IAC3B,iBAAiB;IACjB,eAAe;IACf,WAAW,EAAE,gBAAgB,EAAE,YAAY;IAC3C,kBAAkB,EAAE,gBAAgB,EAAE,eAAe;IACrD,kCAAkC;EACpC;EACA,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;EAC/D;IACE,eAAe,EAAE,gBAAgB,EAAE,WAAW;IAC9C,yBAAyB,EAAE,qBAAqB;IAChD,qBAAqB;EACvB;;EAEA,qBAAqB;EACrB;IACE,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;EAClB;EACA,mBAAmB,gBAAgB,EAAE;EACrC;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;EACjB;EACA,qBAAqB,mBAAmB,EAAE;EAC1C;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;wBACsB,kBAAkB,EAAE;EAC1C;IACE,kBAAkB;IAClB,WAAW;IACX,6BAA6B;IAC7B,sBAAsB;IACtB,eAAe;EACjB;EACA,8BAA8B,mBAAmB,EAAE;;EAEnD,aAAa;EACb;IACE,WAAW,EAAE,YAAY;IACzB,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;IAC5C,eAAe,EAAE,WAAW,EAAE,eAAe;IAC7C,mBAAmB;EACrB;;EAEA,iBAAiB;EACjB,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;EAC/D;IACE,WAAW,EAAE,YAAY;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,eAAe,EAAE,gBAAgB,EAAE,cAAc;IACjD,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB;EAClF;;EAEA,kBAAkB;EAClB;IACE,qBAAqB;IACrB,eAAe,EAAE,gBAAgB;IACjC,mBAAmB,EAAE,cAAc;IACnC,iBAAiB,EAAE,mBAAmB;IACtC,yBAAyB;EAC3B;;EAEA,UAAU;EACV;IACE,eAAe,EAAE,gBAAgB,EAAE,cAAc;IACjD,wCAAwC;EAC1C;EACA;IACE,eAAe,EAAE,WAAW;IAC5B,6BAA6B;IAC7B,wCAAwC;IACxC,eAAe;EACjB;;EAEA,gBAAgB;EAChB;IACE,oBAAoB,EAAE,mBAAmB;IACzC,eAAe,EAAE,gBAAgB;IACjC,wCAAwC;IACxC,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;IACnD,iBAAiB,EAAE,gBAAgB;IACnC,iBAAiB,EAAE,mBAAmB;IACtC,eAAe,EAAE,yBAAyB;EAC5C;EACA,kBAAkB,YAAY,EAAE;EAChC,mBAAmB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;EACnF,qBAAqB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;EAErF,aAAa;EACb;IACE,YAAY,EAAE,eAAe;IAC7B,kBAAkB;IAClB,yBAAyB,EAAE,gBAAgB;IAC3C,eAAe,EAAE,WAAW;IAC5B,eAAe;IACf,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;IACnD,qBAAqB;IACrB,kCAAkC;EACpC;EACA,qBAAqB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;EAEjF,UAAU;EACV,SAAS,eAAe,EAAE,WAAW,EAAE,wCAAwC,EAAE;;EAEjF,aAAa;EACb,gBAAgB,kBAAkB,EAAE,6BAA6B,EAAE;;EAEnE,eAAe;EACf;IACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;IAClE,eAAe,EAAE,SAAS;IAC1B,kBAAkB;IAClB,6BAA6B;EAC/B;EACA,eAAe,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,WAAW,EAAE;EAC3F,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;EAC9D;IACE,WAAW,EAAE,YAAY;IACzB,kBAAkB;IAClB,yBAAyB,EAAE,gBAAgB;IAC3C,eAAe,EAAE,WAAW;IAC5B,eAAe;IACf,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;IAC3D,qBAAqB;IACrB,kCAAkC;EACpC;EACA,oBAAoB,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;EAC7E,+CAA+C,mBAAmB,EAAE,cAAc,EAAE;EACpF,sBAAsB,YAAY,EAAE,eAAe,EAAE;;EAErD,gBAAgB;EAChB;IACE,eAAe,EAAE,QAAQ;IACzB,+BAA+B;IAC/B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;IAC3D,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,wCAAwC;IACxC,kCAAkC;EACpC;EACA;IACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;IAClE,uBAAuB;IACvB,gCAAgC;EAClC;EACA,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;EACrE;IACE,WAAW,EAAE,YAAY;IACzB,kBAAkB,EAAE,yBAAyB;IAC7C,mBAAmB,EAAE,eAAe;IACpC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;IAC3D,WAAW,EAAE,eAAe,EAAE,qBAAqB;EACrD;EACA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;EACpF,iBAAiB,kBAAkB,EAAE;EACrC,mBAAmB,kBAAkB,EAAE,6BAA6B,EAAE,aAAa,EAAE,yBAAyB,EAAE,SAAS,EAAE;;EAE3H;IACE,eAAe,EAAE,gBAAgB,EAAE,WAAW;IAC9C,yBAAyB,EAAE,qBAAqB;IAChD,kBAAkB,EAAE,cAAc;EACpC;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,kCAAkC;IAClC,mBAAmB;EACrB;EACA,wBAAwB,qBAAqB,EAAE;EAC/C,4BAA4B,WAAW,EAAE;;EAEzC;IACE,WAAW,EAAE,aAAa;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;EACrB","sourcesContent":["/* :root {\n  --sidebar-width: 20%;\n}\n\n.bodyContainer {\n  height: 100vh;\n  display: flex;\n}\n\n.sidebarMain {\n  width: var(--sidebar-width);\n  background-color: #fff;\n  height: 100vh;\n  transition: width 0.3s ease-in-out;\n  overflow: auto;\n}\n\n.sidebarHidden {\n  width: 0;\n}\n\n.sidebarVisible {\n  width: var(--sidebar-width);\n}\n.brandLogo img {\n  height: 50px;\n}\n.brandLogo p {\n  font-size: 30px;\n  font-weight: 500;\n  font-family: poppins;\n  color: #0e0ed4;\n}\n.lightBlack {\n  background-color: #4a4a4a !important;\n}\n.menuItem img {\n  height: 18px;\n}\n.menuItem p {\n  font-size: 14px;\n  font-family: poppins;\n  font-weight: 600;\n}\n.dropIcon {\n  height: 10px;\n}\n.mainContainer {\n  background-color: white;\n  width: calc(100% - var(--sidebar-width));\n  height: 100vh;\n  transition: width 0.3s ease-in-out;\n  overflow: auto;\n}\n\n.sidebarHidden + .mainContainer {\n  width: 100%;\n}\n.subMenu {\n  font-family: 10px;\n  font-family: \"Gill Sans\", \"Gill Sans MT\", Calibri, \"Trebuchet MS\", sans-serif;\n  font-weight: 600;\n  opacity: 0.7;\n}\n.subMenu i {\n  font-size: 6px;\n  margin-right: 5px;\n  position: relative;\n  top: -3px;\n}\n\n\n@media screen and (max-width: 768px) {\n  :root {\n    --sidebar-width: 100%;\n  }\n  .sidebarMain {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    width: 100%;\n    z-index: 2;\n  }\n  .sidebarHidden {\n    width: 0;\n  }\n  .sidebarVisible {\n    width: 100%;\n  }\n}\n.barIcon {\n  height: 20px;\n  filter: brightness(0) invert(1);\n}\n.topNavMain {\n  background-color: red;\n  height: 130px;\n}\n.navRightDiv img {\n  height: 30px;\n}\n.textPrimary {\n  color: #851504;\n}\n.notificationDiv p {\n  font-size: 10px;\n  background-color: red;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  text-align: center;\n  color: white;\n  font-weight: 500;\n  position: relative;\n  top: 15px;\n  left: -10px;\n}\n.notificationDiv img {\n  height: 28px;\n  position: relative;\n  top: 2px;\n  filter: brightness(0) invert(1);\n}\n.notificationDiv {\n  cursor: pointer;\n}\n.loginMain {\n  width: 400px;\n}\n.bgGradient {\n  background: linear-gradient(to bottom, skyblue, white);\n}\n.loginMain h3 {\n  font-family: poppins;\n}\n.topCard {\n  background: white;\n}\n.topCard img {\n  height: 35px;\n  filter: brightness(0) invert(1);\n}\n.topCard h2 {\n  font-family: poppins;\n  margin-bottom: 0px;\n}\n.topCard h6 {\n  font-family: sans-serif;\n  font-weight: 600;\n  margin-bottom: 0px;\n}\n.borderRadius24 {\n  border-radius: 24px;\n}\n.borderRadius16 {\n  border-radius: 16px;\n}\n\n.topActionForm input,\nselect,\nbutton {\n  height: 45px;\n}\n.table > :not(caption) > * > * {\n  padding: 1.5rem 0.5rem;\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 1px;\n  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);\n}\n.noRecordFoundMain {\n  height: 75vh;\n  background-color: #353535;\n  border-radius: 20px;\n}\n.noRecordFoundInner {\n  width: 800px;\n  white-space: wrap;\n  text-align: center;\n}\n.noRecordFoundInner h1 {\n  margin-bottom: 80px;\n  font-size: 50px;\n  font-family: \"poppins\";\n}\n.noRecordFoundInner p {\n  font-family: \"sans-sirf\";\n  font-size: 30px;\n}\n.driverApprovalMain input:checked {\n  height: 30px;\n  font-size: 30px;\n}\n.chatBox {\n  height: 65vh;\n  background-color: #f5f5f5;\n  border-radius: 30px;\n  position: relative;\n  overflow: scroll;\n}\n.bottomChatAction {\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  right: 10px;\n  margin: 0px 5px;\n  background: #fff;\n  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 24px;\n}\n.bottomChatAction img{\n  height: 30px;\n}\n.bottomChatAction input{\n  border: none;\n  outline: none;\n  border-radius: 24px 0px 0px 24px;\n}\n.bottomChatAction button{\n  height: 40px;\n  border-radius: 0px 24px 24px 0px;\n}\n\ntd ul {\n  max-height: 150px;\n  overflow-y: auto;\n}\ntd ul li {\n  font-size: 14px;\n  border: 1px solid #ddd;\n}\n.orderMainCard{\n  background-color: gainsboro;\n  border-radius: 20px;\n}\n\n.flatCart p{\n  margin-bottom: 0px;\n  font-size: 13px;\n  font-family: \"poppins\";\n}\n.boxCart{\n  border-radius: 12px;\n}\n.boxCart p{\n margin-bottom: 4px;\n  font-size: 14px;\n  font-family: \"poppins\";\n}\n.boxCart b{\n  color: #363435;\n}\n.lightGreenBg{\n  background-color: #c34b36;\n}\n\n.custom-pagination .page-item .page-link {\n  background-color: #f0f0f0;\n  color: #000;\n  border: none;\n  margin: 0 5px;\n  border-radius: 6px;\n  min-width: 44px;\n  text-align: center;\n}\n\n.custom-pagination .page-item.active .page-link {\n  background-color: #333;\n  color: #fff;\n}\n\n.custom-pagination .page-item.disabled .page-link {\n  color: #828282;\n  pointer-events: none;\n  background-color: #f0f0f0;\n}\n\n.custom-select {\n  border-radius: 6px;\n  background-color: #f0f0f0;\n  border: none;\n  color: #000;\n}\n\n.order-tracker {\n  list-style: none;\n  padding-left: 0;\n  margin-left: 15px;\n  position: relative;\n}\n\n.order-tracker li {\n  position: relative;\n  margin-bottom: 30px;\n  padding-left: 40px;\n}\n\n.order-tracker li:not(:last-child)::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 32px;\n  bottom: -30px;\n  width: 2px;\n  border-left: 2px dashed #ccc;\n  z-index: 0;\n}\n\n.order-tracker li .icon {\n  position: absolute;\n  left: -16px;\n  top: 0;\n  width: 32px;\n  height: 32px;\n  background: #e0f7fa;\n  color: #0d6efd;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  border: 2px solid #0d6efd;\n  z-index: 1;\n}\n\n\n.order-tracker li.completed .icon {\n  background-color: #d1f7d6;\n  color: #28a745;\n  border-color: #28a745;\n}\n\n.order-tracker li.pending .icon {\n  background-color: #f0f0f0;\n  color: #999;\n  border-color: #ddd;\n}\n\n.order-tracker li .details {\n  margin-left: 10px;\n}\n\n\n.order-tracker li.active .icon {\n  background-color: #e0f7fa;\n  color: #0d6efd;\n  border-color: #0d6efd;\n}\n\n\n\n.productDetailsDiv h1{\n  font-family: poppins;\n  font-size: 30px;\n  font-weight: 600;\n  color:gray\n}\n.reviewDiv a{\n  font-family: sans-serif;\n}\n.productDetailsDiv h5{\n  font-family: poppins;\n  font-size: 16px;\n  font-weight: 500;\n}\n.varientDiv span{\n  border: 1px solid green;\n  border-radius: 2px;\n  font-family: sans-serif;\n}\n.counterDiv p{\n  font-family: 16px;\n  font-family: monospace;\n  border: 1px solid gray;\n  text-align: center;\n  padding: 8px 14px;\n  border-radius: 2px;\n  margin-right: 6px;\n  color: gray;\n}\n.productDetailsBtn button{\n  width: 48%;\n  background-color: #3d9970;\n  padding: 8px 0px;\n  font-family: poppins;\n  border: none;\n  border-radius: 6px;\n  color: white;\n}\n.productDetailsLeftBtnGroup p{\n  font-family: 16px;\n  font-family: poppins;\n  border: 1px solid gray;\n  text-align: center;\n  padding: 8px 14px;\n  border-radius: 2px;\n  width: 200px;\n  color: gray;\n  margin-bottom: 0px;\n  cursor: pointer;\n}\n.breadcrumb p{\n  font-family: poppins;\n  margin-right: 8px;\n}\n.discountedPrice{\n   font-size: 25px;\n   color: #00b33c;\n}\n@media (max-width: 500px) {\n  .productDetailsDiv h1{\n\n  font-size: 16px;\n  \n}\n.counterDiv p{\n  font-family: 10px;\n  \n  padding: 3px 10px;\n  border-radius: 2px;\n  margin-right: 4px;\n  color: gray;\n}\n.varientDiv span{\n  font-size: 12px;\n}\n.row {\n    \n    margin-left: 0px !important;\n    margin-right: 0px !important\n}\n.breadcrumb p{\n  font-size: 11px;\n  margin-bottom: 0px;\n}\n.productDetailsDiv h5{\n  \n  font-size: 12px;\n  \n}\n.productDetailsBtn button{\n  \n  padding: 6px 0px;\n  \n  border-radius: 4px;\n  \n}\n.discountedPrice{\n   font-size: 16px;\n   color: #00b33c;\n}\n.productDetailsLeftBtnGroup p{\n  font-size: 10px !important;\n  padding: 4px 7px;\n  border-radius: 2px;\n  width: 100px;\n}\n}\n.productDetailsDiv h4{\n   font-family: poppins;\n  font-size: 16px;\n  font-weight: 500;\n  margin: 10px 0px;\n  color: gray;\n}\n.productDetailsDiv h3{\n   font-family: poppins;\n  font-size: 30px;\n  font-weight: 500;\n  margin: 10px 0px;\n  color: black;\n}\nselect.form-control {\n  appearance: auto;\n  -webkit-appearance: auto;\n  -moz-appearance: auto;\n}\n\n.starGroup img{\nheight: 20px !important;\nmargin-right: 5px;\n}\n.reviewBox img{\n  height: 50px;\n}\n.reviewBox{\n  border-radius: 12px;\n  border: 1px solid gray;\n  background-color: whitesmoke;\n}\n\n.custom-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  background-color: rgba(0, 0, 0, 0.4);\n  z-index: 9999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n}\n\n.custom-modal-content {\n  background: #fff;\n  border-radius: 16px;\n  padding: 30px;\n  max-width: 960px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  position: relative;\n  animation: zoomIn 0.3s ease;\n}\n\n.custom-scroll-area {\n  max-height: 400px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n}\n\n\n@keyframes zoomIn {\n  from {\n    opacity: 0;\n    transform: scale(0.85);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n.table-container-with-sticky-header {\n  max-height: 400px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  position: relative;\n}\n\n.table-container-with-sticky-header thead th {\n  position: sticky;\n  top: 0;\n  background-color: #f8f9fa; \n  z-index: 2;\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);\n}\n\n.form-select option:disabled {\n  color: #999;\n}\n\n\n.combo-product-list {\n  max-height: none !important;\n  overflow: visible !important;\n  padding-left: 15px;\n}\n\n@media print {\n  .combo-product-list {\n    list-style: disc !important;\n    font-size: 12px;\n    line-height: 1.4;\n  }\n}\n\n\n\n@media print {\n  .print-area {\n    overflow: visible !important;\n    height: auto !important;\n    max-height: none !important;\n  }\n  .bodyContainer,\n  .mainContainer,\n  .card {\n    overflow: visible !important;\n  }\n}\n */\n\n /* ─── SIDEBAR VARIABLES ─────────────────────────────── */\n/* ─── SIDEBAR VARIABLES ─────────────────────────────── */\n\n\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@500&display=swap');\n\n:root {\n  --sidebar-width: 260px;\n  --sb-bg:         #1c0a0a;\n  --sb-accent:     #a60808;\n  --sb-accent-lt:  rgba(192, 57, 43, 0.14);\n  --sb-border:     rgba(255, 255, 255, 0.06);\n  --sb-text:       rgba(255, 255, 255, 0.52);\n  --sb-text-hi:    rgba(255, 255, 255, 0.88);\n  --sb-icon-bg:    rgba(255, 255, 255, 0.07);\n}\n\n/* ─── SIDEBAR SHELL ─────────────────────────────────── */\n.sidebarMain {\n  width: var(--sidebar-width);\n  background-color: var(--sb-bg);\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  transition: width 0.3s ease-in-out;\n  overflow: hidden;\n  font-family: 'Segoe UI', sans-serif;\n}\n.sidebarHidden  { width: 0; }\n.sidebarVisible { width: var(--sidebar-width); }\n\n/* ─── HEADER / LOGO ─────────────────────────────────── */\n.sb-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 22px 20px 18px;\n  border-bottom: 1px solid var(--sb-border);\n  flex-shrink: 0;\n}\n.sb-logo-box {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  background: var(--sb-accent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n.sb-logo-img {\n  height: 30px;\n  width: auto;\n  object-fit: contain;\n  filter: brightness(0) invert(1);\n}\n.sb-brand-name {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n}\n.sb-brand-sub {\n  color: rgba(255, 255, 255, 0.28);\n  font-size: 10px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  margin-top: 1px;\n}\n\n/* ─── SCROLLABLE NAV AREA ───────────────────────────── */\n.sb-nav-area {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px 10px 10px;\n  scrollbar-width: none;\n}\n.sb-nav-area::-webkit-scrollbar { display: none; }\n\n/* ─── SECTION LABELS ────────────────────────────────── */\n.sb-section-label {\n  font-size: 11px;\n  color: rgb(255 255 255 / 88%);\n  text-transform: uppercase;\n  letter-spacing: 1.3px;\n  font-weight: 600;\n  padding: 14px 8px 5px;\n}\n\n/* ─── MENU HEADER ROW ───────────────────────────────── */\n.sb-menu-group { margin-bottom: 1px; }\n\n.sb-menu-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 10px;\n  border-radius: 9px;\n  cursor: pointer;\n  color: var(--sb-text);\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.18s, color 0.18s;\n  user-select: none;\n}\n.sb-menu-header:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: var(--sb-text-hi);\n}\n.sb-menu-header.active {\n  background: var(--sb-accent-lt);\n  color: #e8604c;\n}\n\n/* ─── ICON BOX ──────────────────────────────────────── */\n.sb-icon-box {\n  width: 30px;\n  height: 30px;\n  border-radius: 7px;\n  background: var(--sb-icon-bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  flex-shrink: 0;\n  transition: background 0.18s, color 0.18s;\n}\n.sb-menu-header:hover .sb-icon-box {\n  background: rgba(255, 255, 255, 0.1);\n}\n.sb-menu-header.active .sb-icon-box {\n  background: var(--sb-accent);\n  color: #fff;\n}\n\n.sb-menu-label { flex: 1; }\n\n/* ─── CHEVRON ARROW ─────────────────────────────────── */\n.sb-arrow {\n  font-size: 11px;\n  transition: transform 0.2s;\n  opacity: 0.5;\n}\n.sb-arrow.open { transform: rotate(90deg); }\n\n/* ─── SUBMENU ────────────────────────────────────────── */\n.sb-submenu {\n  padding: 3px 0 4px 50px;\n}\n.sb-sub-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  border-radius: 7px;\n  cursor: pointer;\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 13.5px;\n  transition: background 0.15s, color 0.15s;\n  margin-bottom: 1px;\n}\n.sb-sub-item:hover {\n  color: rgba(255, 255, 255, 0.78);\n  background: rgba(255, 255, 255, 0.04);\n}\n.sb-sub-item.active {\n  color: #e8604c;\n  background: rgba(192, 57, 43, 0.12);\n  font-weight: 500;\n}\n.sb-sub-dot {\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: currentColor;\n  flex-shrink: 0;\n  opacity: 0.65;\n}\n.sb-sub-item.active .sb-sub-dot { opacity: 1; }\n\n/* ─── FOOTER ─────────────────────────────────────────── */\n.sb-footer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 16px;\n  border-top: 1px solid var(--sb-border);\n  flex-shrink: 0;\n}\n.sb-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--sb-accent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n.sb-user-info { flex: 1; }\n.sb-user-name {\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 13px;\n  font-weight: 500;\n}\n.sb-user-role {\n  color: rgba(255, 255, 255, 0.28);\n  font-size: 11px;\n}\n.sb-logout {\n  color: rgba(255, 255, 255, 0.25);\n  font-size: 17px;\n  cursor: pointer;\n  transition: color 0.18s;\n}\n.sb-logout:hover { color: #e8604c; }\n\n/* ─── MOBILE CLOSE BUTTON ───────────────────────────── */\n.sb-close-btn {\n  background: rgba(255, 255, 255, 0.08);\n  border: none;\n  border-radius: 8px;\n  color: rgba(255, 255, 255, 0.6);\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  cursor: pointer;\n  transition: background 0.18s;\n}\n.sb-close-btn:hover { background: rgba(255, 255, 255, 0.14); }\n\n/* ─── MAIN CONTAINER (unchanged logic) ─────────────── */\n.bodyContainer {\n  height: 100vh;\n  display: flex;\n}\n.mainContainer {\n  background-color: white;\n  width: calc(100% - var(--sidebar-width));\n  height: 100vh;\n  transition: width 0.3s ease-in-out;\n  overflow: auto;\n}\n.sidebarHidden + .mainContainer { width: 100%; }\n\n/* ─── MOBILE ─────────────────────────────────────────── */\n@media screen and (max-width: 768px) {\n  :root { --sidebar-width: 100%; }\n  .sidebarMain {\n    position: absolute;\n    top: 0; left: 0;\n    height: 100vh;\n    width: 100%;\n    z-index: 2;\n  }\n  .sidebarHidden  { width: 0; }\n  .sidebarVisible { width: 100%; }\n}\n\n/* ═══════════════════════════════════════════════════════\n   EXISTING STYLES BELOW — unchanged\n   ═══════════════════════════════════════════════════════ */\n\n/* ─── TOP NAV ────────────────────────────────────────── */\n.topNavMain {\n  background: #fff;\n  border-bottom: 1px solid #f0eded;\n  height: 64px;\n  display: flex;\n  align-items: start;\n  padding: 0;\n  flex-shrink: 0;\n  padding-top: 20px;\n}\n.tn-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0 24px;\n}\n.tn-left {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n.tn-hamburger {\n  width: 36px;\n  height: 36px;\n  border-radius: 9px;\n  background: #fdf2f1;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #a60808;\n  font-size: 18px;\n  transition: background 0.18s;\n  flex-shrink: 0;\n}\n.tn-hamburger:hover { background: #f9e0dd; }\n.tn-page-title {\n  font-size: 17px;\n  font-weight: 600;\n  color: #1c0a0a;\n  line-height: 1.2;\n}\n.tn-page-path {\n  font-size: 13px;\n  color: #828282;\n  margin-top: 1px;\n}\n.tn-right {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.tn-icon-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 9px;\n  background: #fdf2f1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n  color: #a60808;\n  font-size: 18px;\n  transition: background 0.18s;\n}\n.tn-icon-btn:hover { background: #f9e0dd; }\n.tn-badge {\n  position: absolute;\n  top: 7px;\n  right: 7px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #a60808;\n  border: 2px solid #fff;\n}\n.tn-divider {\n  width: 1px;\n  height: 28px;\n  background: #f0eded;\n  margin: 0 6px;\n}\n.tn-user-chip {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 10px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.18s;\n}\n.tn-user-chip:hover { background: #fdf2f1; }\n.tn-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #a60808;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n.tn-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n.tn-user-name {\n  font-size: 15px;\n  font-weight: 500;\n  color: #1c0a0a;\n  line-height: 1.2;\n}\n.tn-user-role {\n  font-size: 13px;\n  color: #828282;\n}\n.tn-logout-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: transparent;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #ccc;\n  font-size: 17px;\n  transition: background 0.18s, color 0.18s;\n  margin-left: 2px;\n}\n.tn-logout-btn:hover { background: #fdf2f1; color: #a60808; }\n@media screen and (max-width: 768px) {\n  .tn-page-path { display: none; }\n  .tn-user-text  { display: none; }\n  .tn-inner { padding: 0 14px; }\n}\n\n.barIcon {\n  height: 20px;\n  filter: brightness(0) invert(1);\n}\n.topNavMain {\n  /* background-color: red; */\n  height: 100px;\n}\n.navRightDiv img { height: 30px; }\n.textPrimary { color: #851504; }\n.notificationDiv p {\n  font-size: 10px;\n  background-color: red;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  text-align: center;\n  color: white;\n  font-weight: 500;\n  position: relative;\n  top: 15px;\n  left: -10px;\n}\n.notificationDiv img {\n  height: 28px;\n  position: relative;\n  top: 2px;\n  filter: brightness(0) invert(1);\n}\n.notificationDiv { cursor: pointer; }\n.loginMain { width: 400px; }\n.bgGradient { background: linear-gradient(to bottom, skyblue, white); }\n.loginMain h3 { font-family: poppins; }\n.topCard { background: white; }\n.topCard img {\n  height: 35px;\n  filter: brightness(0) invert(1);\n}\n.topCard h2 { font-family: poppins; margin-bottom: 0px; }\n.topCard h6 { font-family: sans-serif; font-weight: 600; margin-bottom: 0px; }\n.borderRadius24 { border-radius: 24px; }\n.borderRadius16 { border-radius: 16px; }\n.topActionForm input,\nselect,\nbutton { height: 45px; }\n.table > :not(caption) > * > * {\n  padding: 1.5rem 0.5rem;\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 1px;\n  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);\n}\n.noRecordFoundMain {\n  height: 75vh;\n  background-color: #353535;\n  border-radius: 20px;\n}\n.noRecordFoundInner {\n  width: 800px;\n  white-space: wrap;\n  text-align: center;\n}\n.noRecordFoundInner h1 {\n  margin-bottom: 80px;\n  font-size: 50px;\n  font-family: \"poppins\";\n}\n.noRecordFoundInner p {\n  font-family: \"sans-sirf\";\n  font-size: 30px;\n}\n.chatBox {\n  height: 65vh;\n  background-color: #f5f5f5;\n  border-radius: 30px;\n  position: relative;\n  overflow: scroll;\n}\n.bottomChatAction {\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  right: 10px;\n  margin: 0px 5px;\n  background: #fff;\n  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 24px;\n}\n.bottomChatAction img { height: 30px; }\n.bottomChatAction input {\n  border: none;\n  outline: none;\n  border-radius: 24px 0px 0px 24px;\n}\n.bottomChatAction button {\n  height: 40px;\n  border-radius: 0px 24px 24px 0px;\n}\ntd ul { max-height: 150px; overflow-y: auto; }\ntd ul li { font-size: 14px; border: 1px solid #ddd; }\n.orderMainCard { background-color: gainsboro; border-radius: 20px; }\n.flatCart p { margin-bottom: 0px; font-size: 13px; font-family: \"poppins\"; }\n.boxCart { border-radius: 12px; }\n.boxCart p { margin-bottom: 4px; font-size: 14px; font-family: \"poppins\"; }\n.boxCart b { color: #363435; }\n.lightGreenBg { background-color: #c34b36; }\n.custom-pagination .page-item .page-link {\n  background-color: #f0f0f0;\n  color: #000;\n  border: none;\n  margin: 0 5px;\n  border-radius: 6px;\n  min-width: 44px;\n  text-align: center;\n}\n.custom-pagination .page-item.active .page-link {\n  background-color: #333;\n  color: #fff;\n}\n.custom-pagination .page-item.disabled .page-link {\n  color: #828282;\n  pointer-events: none;\n  background-color: #f0f0f0;\n}\n.custom-select {\n  border-radius: 6px;\n  background-color: #f0f0f0;\n  border: none;\n  color: #000;\n}\n.order-tracker { list-style: none; padding-left: 0; margin-left: 15px; position: relative; }\n.order-tracker li { position: relative; margin-bottom: 30px; padding-left: 40px; }\n.order-tracker li:not(:last-child)::before {\n  content: '';\n  position: absolute;\n  left: 0; top: 32px; bottom: -30px;\n  width: 2px;\n  border-left: 2px dashed #ccc;\n  z-index: 0;\n}\n.order-tracker li .icon {\n  position: absolute;\n  left: -16px; top: 0;\n  width: 32px; height: 32px;\n  background: #e0f7fa;\n  color: #0d6efd;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  border: 2px solid #0d6efd;\n  z-index: 1;\n}\n.order-tracker li.completed .icon { background-color: #d1f7d6; color: #28a745; border-color: #28a745; }\n.order-tracker li.pending .icon { background-color: #f0f0f0; color: #999; border-color: #ddd; }\n.order-tracker li .details { margin-left: 10px; }\n.order-tracker li.active .icon { background-color: #e0f7fa; color: #0d6efd; border-color: #0d6efd; }\n.productDetailsDiv h1 { font-family: poppins; font-size: 30px; font-weight: 600; color: gray; }\n.reviewDiv a { font-family: sans-serif; }\n.productDetailsDiv h5 { font-family: poppins; font-size: 16px; font-weight: 500; }\n.varientDiv span { border: 1px solid green; border-radius: 2px; font-family: sans-serif; }\n.counterDiv p {\n  font-family: monospace;\n  border: 1px solid gray;\n  text-align: center;\n  padding: 8px 14px;\n  border-radius: 2px;\n  margin-right: 6px;\n  color: gray;\n}\n.productDetailsBtn button {\n  width: 48%;\n  background-color: #3d9970;\n  padding: 8px 0px;\n  font-family: poppins;\n  border: none;\n  border-radius: 6px;\n  color: white;\n}\n.productDetailsLeftBtnGroup p {\n  font-family: poppins;\n  border: 1px solid gray;\n  text-align: center;\n  padding: 8px 14px;\n  border-radius: 2px;\n  width: 200px;\n  color: gray;\n  margin-bottom: 0px;\n  cursor: pointer;\n}\n.breadcrumb p { font-family: poppins; margin-right: 8px; }\n.discountedPrice { font-size: 25px; color: #00b33c; }\n@media (max-width: 500px) {\n  .productDetailsDiv h1 { font-size: 16px; }\n  .counterDiv p { padding: 3px 10px; border-radius: 2px; margin-right: 4px; color: gray; }\n  .varientDiv span { font-size: 12px; }\n  .row { margin-left: 0px !important; margin-right: 0px !important; }\n  .breadcrumb p { font-size: 11px; margin-bottom: 0px; }\n  .productDetailsDiv h5 { font-size: 12px; }\n  .productDetailsBtn button { padding: 6px 0px; border-radius: 4px; }\n  .discountedPrice { font-size: 16px; color: #00b33c; }\n  .productDetailsLeftBtnGroup p { font-size: 10px !important; padding: 4px 7px; border-radius: 2px; width: 100px; }\n}\n.productDetailsDiv h4 { font-family: poppins; font-size: 16px; font-weight: 500; margin: 10px 0px; color: gray; }\n.productDetailsDiv h3 { font-family: poppins; font-size: 30px; font-weight: 500; margin: 10px 0px; color: black; }\nselect.form-control { appearance: auto; -webkit-appearance: auto; -moz-appearance: auto; }\n.starGroup img { height: 20px !important; margin-right: 5px; }\n.reviewBox img { height: 50px; }\n.reviewBox { border-radius: 12px; border: 1px solid gray; background-color: whitesmoke; }\n.custom-modal-backdrop {\n  position: fixed;\n  top: 0; left: 0;\n  height: 100vh; width: 100vw;\n  background-color: rgba(0, 0, 0, 0.4);\n  z-index: 9999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n}\n.custom-modal-content {\n  background: #fff;\n  border-radius: 16px;\n  padding: 30px;\n  max-width: 960px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  position: relative;\n  animation: zoomIn 0.3s ease;\n}\n.custom-scroll-area { max-height: 400px; overflow-y: auto; border: 1px solid #ddd; border-radius: 8px; }\n@keyframes zoomIn {\n  from { opacity: 0; transform: scale(0.85); }\n  to   { opacity: 1; transform: scale(1); }\n}\n.table-container-with-sticky-header {\n  max-height: 400px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  position: relative;\n}\n.table-container-with-sticky-header thead th {\n  position: sticky;\n  top: 0;\n  background-color: #f8f9fa;\n  z-index: 2;\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);\n}\n.form-select option:disabled { color: #999; }\n.combo-product-list { max-height: none !important; overflow: visible !important; padding-left: 15px; }\n@media print {\n  .combo-product-list { list-style: disc !important; font-size: 12px; line-height: 1.4; }\n  .print-area { overflow: visible !important; height: auto !important; max-height: none !important; }\n  .bodyContainer, .mainContainer, .card { overflow: visible !important; }\n}\n\n\n/* ═══════════════════════════════════════════════════════════\n   adminForm.css\n   Shared design system for all admin Add / Update form pages\n   Theme: DM Sans · Red #a60808 · Dark #1c0a0a · Bg #f5f5f7\n   ═══════════════════════════════════════════════════════════ */\n\n\n/* ── Page wrapper ───────────────────────────────────────── */\n.af-page {\n  background: #f5f5f7;\n  min-height: 100%;\n  padding: 28px;\n  font-family: 'DM Sans', 'Segoe UI', sans-serif;\n  font-size: 15px;\n}\n\n/* ── Page header ────────────────────────────────────────── */\n.af-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 22px;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n.af-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.af-back-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 11px;\n  border: 1px solid #f0eded;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  color: #555;\n  cursor: pointer;\n  transition: all 0.18s;\n  flex-shrink: 0;\n}\n.af-back-btn:hover { background: #fdf2f1; color: #a60808; border-color: #f0c0b8; }\n\n.af-page-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #1c0a0a;\n  letter-spacing: -0.4px;\n}\n.af-breadcrumb {\n  font-size: 13px;\n  color: #aaa;\n  margin-top: 3px;\n  font-weight: 500;\n}\n.af-breadcrumb span { color: #a60808; }\n\n/* Header right badge (e.g. \"Editing ID: XXXXXX\" or step badge) */\n.af-header-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  background: #fdf2f1;\n  border: 1px solid #f0c0b8;\n  border-radius: 10px;\n  padding: 7px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #a60808;\n}\n\n/* Step badge variant */\n.af-step-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #1c0a0a;\n  border-radius: 10px;\n  padding: 8px 18px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: 0.3px;\n}\n.af-step-badge .af-step-num {\n  background: #a60808;\n  border-radius: 6px;\n  padding: 2px 8px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n/* ── Card ───────────────────────────────────────────────── */\n.af-card {\n  background: #fff;\n  border-radius: 16px;\n  border: 1px solid #f0eded;\n  padding: 28px 28px 32px;\n  margin-bottom: 18px;\n}\n\n/* Section title inside card */\n.af-section-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #a60808;\n  text-transform: uppercase;\n  letter-spacing: 0.9px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.af-section-title::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: #f0eded;\n}\n\n/* ── Form grid ──────────────────────────────────────────── */\n.af-grid   { display: grid; gap: 20px; }\n.af-grid-1 { grid-template-columns: 1fr; }\n.af-grid-2 { grid-template-columns: 1fr 1fr; }\n.af-grid-3 { grid-template-columns: 1fr 1fr 1fr; }\n.af-grid-4 { grid-template-columns: 1fr 1fr 1fr 1fr; }\n@media (max-width: 900px) { .af-grid-3, .af-grid-4 { grid-template-columns: 1fr 1fr; } }\n@media (max-width: 600px) { .af-grid-2, .af-grid-3, .af-grid-4 { grid-template-columns: 1fr; } }\n\n/* ── Field ──────────────────────────────────────────────── */\n.af-field { display: flex; flex-direction: column; gap: 7px; }\n\n.af-label {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #333;\n  letter-spacing: 0.1px;\n}\n.af-label .af-req  { color: #a60808; margin-left: 2px; }\n.af-label .af-hint { font-size: 12px; color: #aaa; font-weight: 400; margin-left: 5px; }\n\n/* ── Inputs ─────────────────────────────────────────────── */\n.af-input,\n.af-select,\n.af-textarea {\n  height: 46px;\n  border-radius: 11px;\n  border: 1px solid #ede9e9;\n  padding: 0 16px;\n  font-size: 15px;\n  color: #333;\n  background: #fafafa;\n  outline: none;\n  font-family: 'DM Sans', sans-serif;\n  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;\n  width: 100%;\n  box-sizing: border-box;\n}\n.af-input:focus,\n.af-select:focus,\n.af-textarea:focus {\n  border-color: #f0c0b8;\n  background: #fff;\n  box-shadow: 0 0 0 3px rgba(192,57,43,0.07);\n}\n.af-input::placeholder,\n.af-textarea::placeholder { color: #ccc; }\n.af-input.af-error { border-color: #e74c3c; background: #fff8f8; }\n.af-input:disabled,\n.af-select:disabled { opacity: 0.55; cursor: not-allowed; }\n\n.af-textarea {\n  height: auto;\n  padding: 14px 16px;\n  resize: vertical;\n  line-height: 1.6;\n}\n\n.af-select {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23aaa' stroke-width='2.5'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 14px center;\n  background-color: #fafafa;\n  padding-right: 38px;\n  cursor: pointer;\n}\n\n/* Status select color variants */\n.af-select.status-active   { border-color: #a8e6b0; background: #f2fdf4; color: #1e8449; }\n.af-select.status-inactive { border-color: #f5d49a; background: #fefdf2; color: #b7770d; }\n\n/* ── React-Select custom theme ──────────────────────────── */\n.af-react-select .select__control {\n  border-radius: 11px !important;\n  border: 1px solid #ede9e9 !important;\n  background: #fafafa !important;\n  min-height: 46px !important;\n  font-size: 15px !important;\n  font-family: 'DM Sans', sans-serif !important;\n  box-shadow: none !important;\n  transition: border-color 0.15s, box-shadow 0.15s !important;\n}\n.af-react-select .select__control--is-focused {\n  border-color: #f0c0b8 !important;\n  background: #fff !important;\n  box-shadow: 0 0 0 3px rgba(192,57,43,0.07) !important;\n}\n.af-react-select .select__multi-value {\n  background: #fdf2f1 !important;\n  border-radius: 6px !important;\n}\n.af-react-select .select__multi-value__label {\n  color: #a60808 !important;\n  font-size: 13px !important;\n  font-weight: 600 !important;\n}\n.af-react-select .select__multi-value__remove:hover {\n  background: #f0c0b8 !important;\n  color: #a60808 !important;\n}\n.af-react-select .select__option--is-focused  { background: #fdf2f1 !important; }\n.af-react-select .select__option--is-selected { background: #a60808 !important; color: #fff !important; }\n.af-react-select .select__placeholder { color: #ccc !important; font-size: 15px !important; }\n.af-react-select .select__menu {\n  border-radius: 11px !important;\n  border: 1px solid #f0eded !important;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.08) !important;\n  font-family: 'DM Sans', sans-serif !important;\n  font-size: 15px !important;\n}\n\n/* ── Banner / Image upload ──────────────────────────────── */\n.af-banner-wrap {\n  border-radius: 12px;\n  border: 2px dashed #ede9e9;\n  overflow: hidden;\n  background: #fafafa;\n  transition: border-color 0.18s;\n  cursor: pointer;\n}\n.af-banner-wrap:hover { border-color: #f0c0b8; }\n.af-banner-preview {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n  display: block;\n}\n.af-banner-placeholder {\n  height: 200px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n.af-banner-placeholder i { font-size: 38px; color: #e8d0cd; }\n.af-banner-placeholder p { font-size: 14px; color: #bbb; font-weight: 500; margin: 0; }\n\n.af-file-input {\n  margin-top: 10px;\n  width: 100%;\n  font-size: 14px;\n  font-family: 'DM Sans', sans-serif;\n  color: #555;\n}\n.af-file-input::file-selector-button {\n  height: 36px;\n  border-radius: 9px;\n  border: 1px solid #f0eded;\n  background: #fff;\n  padding: 0 16px;\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #a60808;\n  cursor: pointer;\n  margin-right: 12px;\n  font-family: 'DM Sans', sans-serif;\n  transition: background 0.15s;\n}\n.af-file-input::file-selector-button:hover { background: #fdf2f1; }\n\n/* ── Jodit editor ───────────────────────────────────────── */\n.jodit-container {\n  border-radius: 11px !important;\n  border: 1px solid #ede9e9 !important;\n  font-size: 15px !important;\n  overflow: hidden;\n  font-family: 'DM Sans', sans-serif !important;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n.jodit-container:focus-within {\n  border-color: #f0c0b8 !important;\n  box-shadow: 0 0 0 3px rgba(192,57,43,0.07) !important;\n}\n.jodit-toolbar__box {\n  border-bottom: 1px solid #f0eded !important;\n  background: #fafafa !important;\n}\n.jodit-wysiwyg {\n  font-family: 'DM Sans', sans-serif !important;\n  font-size: 15px !important;\n  color: #333 !important;\n  min-height: 160px !important;\n}\n\n/* ── Skeleton loader ────────────────────────────────────── */\n.af-skeleton {\n  background: linear-gradient(90deg, #f0eded 25%, #e8e4e4 50%, #f0eded 75%);\n  background-size: 200% 100%;\n  animation: af-shimmer 1.4s infinite;\n  border-radius: 8px;\n  height: 46px;\n  width: 100%;\n}\n@keyframes af-shimmer {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ── Action bar (bottom) ────────────────────────────────── */\n.af-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n}\n.af-required-note {\n  font-size: 13px;\n  color: #bbb;\n  font-style: italic;\n  margin-right: auto;\n}\n.af-required-note span { color: #a60808; }\n\n.af-cancel-btn {\n  height: 48px;\n  padding: 0 28px;\n  border-radius: 12px;\n  border: 1px solid #ede9e9;\n  background: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  color: #666;\n  cursor: pointer;\n  font-family: 'DM Sans', sans-serif;\n  transition: all 0.18s;\n}\n.af-cancel-btn:hover { background: #f5f5f7; color: #333; }\n\n.af-submit-btn {\n  height: 48px;\n  padding: 0 36px;\n  border-radius: 12px;\n  border: none;\n  background: #a60808;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  font-family: 'DM Sans', sans-serif;\n  letter-spacing: 0.2px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: background 0.18s, transform 0.1s, opacity 0.18s;\n}\n.af-submit-btn:hover:not(:disabled) { background: #a93226; transform: translateY(-1px); }\n.af-submit-btn:active:not(:disabled) { transform: translateY(0); }\n.af-submit-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* Next step button (dark) */\n.af-next-btn {\n  height: 48px;\n  padding: 0 36px;\n  border-radius: 12px;\n  border: none;\n  background: #a60808;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  font-family: 'DM Sans', sans-serif;\n  letter-spacing: 0.2px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: background 0.18s, transform 0.1s, opacity 0.18s;\n}\n.af-next-btn:hover:not(:disabled) { background: #a60808; transform: translateY(-1px); }\n.af-next-btn:active:not(:disabled) { transform: translateY(0); }\n.af-next-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* Loader spin */\n@keyframes af-spin {\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n.af-spin { animation: af-spin 1s linear infinite; }\n\n/* ── Error text ─────────────────────────────────────────── */\n.af-error-msg {\n  font-size: 12.5px;\n  color: #e74c3c;\n  margin-top: 4px;\n  font-weight: 500;\n}\n\n/* ── Info/helper text below field ───────────────────────── */\n.af-helper {\n  font-size: 12px;\n  color: #bbb;\n  margin-top: 2px;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* common css for list pages  */\n\n\n  .pl-root {\n    background: #f5f5f7;\n    min-height: 100%;\n    padding: 28px;\n    font-family: 'DM Sans', 'Segoe UI', sans-serif;\n  }\n\n  /* ── Stat grid ── */\n  .pl-stat-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 14px;\n    margin-bottom: 22px;\n  }\n  @media (max-width: 900px)  { .pl-stat-grid { grid-template-columns: repeat(2,1fr); } }\n  @media (max-width: 560px)  { .pl-stat-grid { grid-template-columns: 1fr; } }\n\n  .pl-stat-card {\n    background: #fff;\n    border-radius: 14px;\n    padding: 18px 20px;\n    border: 1px solid #f0eded;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n  .pl-stat-icon {\n    width: 46px; height: 46px;\n    border-radius: 12px;\n    background: #fdf2f1;\n    display: flex; align-items: center; justify-content: center;\n    font-size: 22px;\n    color: #a60808;\n    flex-shrink: 0;\n  }\n  .pl-stat-val {\n    font-size: 26px;\n    font-weight: 700;\n    color: #1c0a0a;\n    line-height: 1;\n    font-family: 'JetBrains Mono', monospace;\n  }\n  .pl-stat-lbl {\n    font-size: 14px;\n    color: #828282;\n    margin-top: 5px;\n    font-weight: 500;\n  }\n\n  /* ── Toolbar ── */\n  .pl-toolbar {\n    background: #fff;\n    border-radius: 14px;\n    padding: 18px 22px;\n    border: 1px solid #f0eded;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 16px;\n  }\n  .pl-toolbar-title {\n    font-size: 20px;\n    font-weight: 700;\n    color: #1c0a0a;\n    margin-right: auto;\n  }\n\n  .pl-input {\n    height: 40px;\n    border-radius: 10px;\n    border: 1px solid #f0eded;\n    padding: 0 14px;\n    font-size: 14px;\n    color: #444;\n    background: #f9f9f9;\n    outline: none;\n    min-width: 170px;\n    font-family: 'DM Sans', sans-serif;\n  }\n  .pl-input:focus { border-color: #f0c0b8; }\n  .pl-input::placeholder { color: #bbb; }\n\n  .pl-select {\n    height: 40px;\n    border-radius: 10px;\n    border: 1px solid #f0eded;\n    padding: 0 14px;\n    font-size: 14px;\n    color: #555;\n    background: #f9f9f9;\n    outline: none;\n    cursor: pointer;\n    font-family: 'DM Sans', sans-serif;\n  }\n  .pl-select:focus { border-color: #f0c0b8; }\n\n  /* buttons */\n  .pl-btn {\n    height: 40px;\n    padding: 0 18px;\n    border-radius: 10px;\n    border: none;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    display: inline-flex; align-items: center; gap: 7px;\n    white-space: nowrap;\n    transition: all 0.18s;\n    font-family: 'DM Sans', sans-serif;\n  }\n  .pl-btn-red    { background: #a60808; color: #fff; }\n  .pl-btn-red:hover    { background: #a93226; }\n  .pl-btn-dark   { background: #1c0a0a; color: #fff; }\n  .pl-btn-dark:hover   { background: #2e1010; }\n  .pl-btn-blue   { background: #2980b9; color: #fff; }\n  .pl-btn-blue:hover   { background: #2471a3; }\n  .pl-btn-danger { background: #fdecea; color: #a60808; border: 1px solid #f0c0b8; }\n  .pl-btn-danger:hover:not(:disabled) { background: #fbd5d1; }\n  .pl-btn-danger:disabled { opacity: 0.45; cursor: default; }\n\n  /* download dropdown */\n  .pl-download-wrap { position: relative; }\n  .pl-dropdown-menu {\n    position: absolute;\n    top: calc(100% + 6px);\n    right: 0;\n    background: #fff;\n    border: 1px solid #f0eded;\n    border-radius: 10px;\n    padding: 6px;\n    z-index: 200;\n    min-width: 200px;\n    box-shadow: 0 4px 20px rgba(0,0,0,0.09);\n  }\n  .pl-dropdown-divider { height: 1px; background: #f0eded; margin: 5px 0; }\n  .pl-dropdown-item {\n    display: block; width: 100%;\n    padding: 9px 14px;\n    font-size: 14px;\n    color: #444; background: none; border: none;\n    border-radius: 7px; text-align: left; cursor: pointer;\n    font-family: 'DM Sans', sans-serif;\n  }\n  .pl-dropdown-item:hover { background: #fdf2f1; color: #a60808; }\n  .pl-dropdown-label {\n    font-size: 11px; font-weight: 700; color: #bbb;\n    text-transform: uppercase; letter-spacing: 0.6px;\n    padding: 6px 14px 3px;\n  }\n\n  /* ── Table card ── */\n  .pl-table-wrap {\n    background: #fff;\n    border-radius: 14px;\n    border: 1px solid #f0eded;\n    overflow: hidden;\n  }\n  .pl-table-scroll { overflow-x: auto; }\n  .pl-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 15px;\n  }\n  .pl-table thead tr { background: #fdf2f1; }\n  .pl-table th {\n    padding: 14px 16px;\n    text-align: left;\n    font-size: 12px;\n    font-weight: 700;\n    color: #a60808;\n    text-transform: uppercase;\n    letter-spacing: 0.6px;\n    white-space: nowrap;\n  }\n  .pl-table th.center,\n  .pl-table td.center { text-align: center; }\n  .pl-table td {\n    padding: 14px 16px;\n    color: #444;\n    border-top: 1px solid #f7f5f5;\n    vertical-align: middle;\n    font-size: 15px;\n  }\n  .pl-table tbody tr:hover td { background: #fdfafa; }\n\n  /* checkbox */\n  .pl-check {\n    width: 16px; height: 16px;\n    accent-color: #a60808;\n    cursor: pointer;\n  }\n  .pl-check-label {\n    display: flex; align-items: center; gap: 7px;\n    font-size: 13px; color: #888; cursor: pointer;\n    white-space: nowrap;\n  }\n\n  /* product cell */\n  .pl-prod-cell { display: flex; align-items: center; gap: 12px; }\n  .pl-prod-img {\n    width: 48px; height: 48px;\n    border-radius: 10px;\n    object-fit: cover;\n    border: 1px solid #f0eded;\n    background: #fdf2f1;\n    flex-shrink: 0;\n  }\n  .pl-prod-name {\n    font-size: 15px; font-weight: 600; color: #1c0a0a;\n    max-width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\n  }\n\n  /* category chip */\n  .pl-cat-chip {\n    display: inline-block;\n    font-size: 12px; font-weight: 600;\n    background: #fdf2f1; color: #a60808;\n    padding: 3px 10px; border-radius: 20px;\n    border: 1px solid #f0c0b8;\n  }\n\n  /* price */\n  .pl-price-main {\n    font-size: 16px; font-weight: 700; color: #1c0a0a;\n    font-family: 'JetBrains Mono', monospace;\n  }\n  .pl-price-strike {\n    font-size: 13px; color: #bbb;\n    text-decoration: line-through;\n    font-family: 'JetBrains Mono', monospace;\n    margin-top: 2px;\n  }\n\n  /* stock badge */\n  .pl-stock {\n    display: inline-flex; align-items: center;\n    font-size: 14px; font-weight: 600;\n    font-family: 'JetBrains Mono', monospace;\n    color: #1c0a0a;\n  }\n\n  /* status badge */\n  .pl-badge {\n    display: inline-flex; align-items: center; gap: 5px;\n    font-size: 12.5px; font-weight: 700;\n    padding: 4px 12px; border-radius: 20px;\n    cursor: pointer; transition: opacity 0.15s;\n  }\n  .pl-badge:hover { opacity: 0.8; }\n  .pl-badge.active { background: #e8f8ef; color: #27ae60; border: 1px solid #b7e4c7; }\n  .pl-badge.inactive { background: #fff5e6; color: #e67e22; border: 1px solid #fcd9a0; }\n\n  /* view btn */\n  .pl-view-btn {\n    height: 34px; padding: 0 16px;\n    border-radius: 9px;\n    border: 1px solid #f0eded; background: #fff;\n    font-size: 14px; color: #555;\n    cursor: pointer;\n    display: inline-flex; align-items: center; gap: 5px;\n    transition: all 0.18s;\n    font-family: 'DM Sans', sans-serif;\n  }\n  .pl-view-btn:hover { background: #fdf2f1; border-color: #f0c0b8; color: #a60808; }\n\n  /* sr no */\n  .pl-sr { font-size: 13px; color: #bbb; font-family: 'JetBrains Mono', monospace; }\n\n  /* skeleton */\n  .pl-skel-cell { padding: 14px 16px; border-top: 1px solid #f7f5f5; }\n\n  /* pagination */\n  .pl-pagination {\n    display: flex; align-items: center; justify-content: space-between;\n    flex-wrap: wrap; gap: 12px;\n    padding: 16px 22px;\n    border-top: 1px solid #f7f5f5;\n  }\n  .pl-show-row { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #888; }\n  .pl-page-btns { display: flex; align-items: center; gap: 5px; }\n  .pl-pg-btn {\n    width: 36px; height: 36px;\n    border-radius: 9px;\n    border: 1px solid #f0eded; background: #fff;\n    font-size: 14px; color: #555;\n    cursor: pointer;\n    display: flex; align-items: center; justify-content: center;\n    transition: all 0.18s;\n    font-family: 'DM Sans', sans-serif;\n  }\n  .pl-pg-btn.active { background: #a60808; color: #fff; border-color: #a60808; }\n  .pl-pg-btn:hover:not(.active):not(:disabled) { background: #fdf2f1; color: #a60808; }\n  .pl-pg-btn:disabled { opacity: 0.4; cursor: default; }\n\n  /* ── Modal ── */\n  .pl-modal-overlay {\n    position: fixed; inset: 0;\n    background: rgba(28,10,10,0.45);\n    display: flex; align-items: center; justify-content: center;\n    z-index: 1050;\n  }\n  .pl-modal {\n    background: #fff;\n    border-radius: 18px;\n    width: 400px;\n    max-width: 95vw;\n    overflow: hidden;\n    box-shadow: 0 20px 60px rgba(0,0,0,0.18);\n    font-family: 'DM Sans', sans-serif;\n  }\n  .pl-modal-header {\n    display: flex; align-items: center; justify-content: space-between;\n    padding: 20px 24px 16px;\n    border-bottom: 1px solid #f0eded;\n  }\n  .pl-modal-title { font-size: 17px; font-weight: 700; color: #1c0a0a; }\n  .pl-modal-close {\n    width: 32px; height: 32px;\n    border-radius: 8px; border: 1px solid #f0eded;\n    background: #f9f9f9; cursor: pointer;\n    display: flex; align-items: center; justify-content: center;\n    color: #888; font-size: 16px; transition: all 0.15s;\n  }\n  .pl-modal-close:hover { background: #fdf2f1; color: #a60808; border-color: #f0c0b8; }\n  .pl-modal-body { padding: 22px 24px; }\n  .pl-modal-footer { padding: 16px 24px; border-top: 1px solid #f0eded; display: flex; justify-content: flex-end; gap: 10px; }\n\n  .pl-field-label {\n    font-size: 12px; font-weight: 700; color: #888;\n    text-transform: uppercase; letter-spacing: 0.5px;\n    margin-bottom: 6px; display: block;\n  }\n  .pl-field-input {\n    width: 100%;\n    height: 42px;\n    border-radius: 10px;\n    border: 1px solid #f0eded;\n    padding: 0 14px;\n    font-size: 15px;\n    color: #1c0a0a;\n    background: #f9f9f9;\n    outline: none;\n    font-family: 'DM Sans', sans-serif;\n    margin-bottom: 14px;\n  }\n  .pl-field-input:focus { border-color: #f0c0b8; }\n  .pl-field-input[readonly] { color: #999; }\n\n  .pl-preview-img {\n    width: 100%; height: 180px;\n    object-fit: contain;\n    border-radius: 10px;\n    border: 1px solid #f0eded;\n    background: #f9f9f9;\n    margin-bottom: 16px;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
